var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.502,
    height: 138.87,
    viewBox: "0 0 270.502 138.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.884,
    y1: 1.135,
    x2: 1.884,
    y2: 0.188,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddf6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.884,
    y1: 1.772,
    x2: 3.884,
    y2: 0.825,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddf6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.543,
    y1: 1.964,
    x2: 3.543,
    y2: 0.635,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 15.146,
    y1: 0.832,
    x2: 15.146,
    y2: 0.021,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 19.165,
    y1: 1.145,
    x2: 19.165,
    y2: -0.935,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa2a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7.998,
    y1: 0.5,
    x2: 1.245,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 12.242,
    y1: 0.5,
    x2: 5.489,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.923,
    y1: 0.894,
    x2: -0.923,
    y2: -0.106,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2.49,
    y1: 0.894,
    x2: 2.49,
    y2: -0.106,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 5.251,
    y1: 1.501,
    x2: 5.251,
    y2: -0.579,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 64.077,
    y1: 2.049,
    x2: 64.077,
    y2: 0.378,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2.567,
    y1: 1.511,
    x2: 2.567,
    y2: 0.612,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2.845,
    y1: 1.451,
    x2: 2.845,
    y2: 0.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3.267,
    y1: 1.501,
    x2: 3.267,
    y2: -0.579,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.922,
    y1: 2.075,
    x2: -0.922,
    y2: 0.03,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.766,
    y1: 4.235,
    x2: 0.766,
    y2: 3.084,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.878,
    y1: 4.45,
    x2: 0.878,
    y2: 5.184,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c2c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -3.349,
    y1: 0.5,
    x2: -10.107,
    y2: 0.5,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 4.715,
    y1: -3.379,
    x2: 4.715,
    y2: 1.564,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 10.967,
    y1: 1.365,
    x2: 10.967,
    y2: -0.244,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0097f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9edff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 15.018,
    y1: -3.377,
    x2: 15.018,
    y2: 1.563,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 106.153,
    y1: 1.817,
    x2: 106.153,
    y2: -0.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopOpacity: 0.949
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 11.51,
    y1: 1.972,
    x2: 11.933,
    y2: 0.247,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 9.428,
    y1: 2.143,
    x2: 9.428,
    y2: -0.305,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 36.947,
    y1: 0.734,
    x2: 36.947,
    y2: -1.577,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 37.334,
    y1: 1.907,
    x2: 37.334,
    y2: 0.153,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 103.567,
    y1: -0.099,
    x2: 103.567,
    y2: 1.329,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7b86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 115.81,
    y1: -0.093,
    x2: 115.81,
    y2: 1.328,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 128.383,
    y1: -0.093,
    x2: 128.383,
    y2: 1.328,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 139.794,
    y1: -0.093,
    x2: 139.794,
    y2: 1.328,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 2.492,
    y1: 2.075,
    x2: 2.492,
    y2: 0.03,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 7.697,
    y1: 4.235,
    x2: 7.697,
    y2: 3.084,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 10.75,
    y1: 4.45,
    x2: 10.75,
    y2: 5.184,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 12.879,
    y1: 0.5,
    x2: 6.121,
    y2: 0.5,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 21.18,
    y1: 7.069,
    x2: 21.18,
    y2: 5.201,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 14.918,
    y1: 8.067,
    x2: 14.918,
    y2: 5.987,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 20.78,
    y1: 10.742,
    x2: 20.78,
    y2: 8.662,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -0.55,
    y1: 0.5,
    x2: 0.767,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 36.194,
    height: 53.874,
    transform: "translate(36.194 53.874) rotate(180)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 6.304,
    y1: 1.179,
    x2: 6.304,
    y2: 0.221,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45356d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e62c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 13.484,
    y1: 1.284,
    x2: 13.484,
    y2: 0.273,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 43.945,
    y1: -0.227,
    x2: 43.945,
    y2: 1.525,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 13.27,
    y1: 2.002,
    x2: 13.27,
    y2: -0.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd69e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 17.494,
    y1: 1.13,
    x2: 17.494,
    y2: -0.953,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 39.417,
    y1: 2.957,
    x2: 39.417,
    y2: -0.198,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 39.417,
    y1: -1.313,
    x2: 39.417,
    y2: 0.99,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 75.286,
    y1: 17.633,
    x2: 75.286,
    y2: 16.148,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 57.279,
    y1: 2.965,
    x2: 57.279,
    y2: -5.186,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 5.473,
    y1: 2.001,
    x2: 5.473,
    y2: -0.08,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 8.246,
    y1: 1.129,
    x2: 8.246,
    y2: -0.952,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 13.686,
    y1: 2.955,
    x2: 13.686,
    y2: -0.198,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 13.686,
    y1: -2.005,
    x2: 13.686,
    y2: 1.342,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 8.441,
    y1: 1.188,
    x2: 8.441,
    y2: -0.893,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 11.773,
    y1: 1.79,
    x2: 11.773,
    y2: -0.29,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 26.305,
    y1: 2.954,
    x2: 26.305,
    y2: -0.198,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 26.305,
    y1: -1.31,
    x2: 26.305,
    y2: 0.991,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 46.608,
    y1: 12.244,
    x2: 46.608,
    y2: 10.756,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 34.763,
    y1: 2.965,
    x2: 34.763,
    y2: -5.187,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0.502,
    y1: 1.447,
    x2: 0.502,
    y2: -0.052,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 20.96,
    y1: -0.097,
    x2: 20.96,
    y2: -1.932,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 30.335,
    y1: -1.247,
    x2: 30.335,
    y2: -3.081,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 51.671,
    y1: -1.516,
    x2: 51.671,
    y2: -3.487,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 79.797,
    y1: 0.677,
    x2: 79.635,
    y2: 0.219,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 10.949,
    y1: 2,
    x2: 10.949,
    y2: -0.08,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 14.727,
    y1: 1.129,
    x2: 14.727,
    y2: -0.951,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 28.563,
    y1: 2.958,
    x2: 28.563,
    y2: -0.198,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 28.563,
    y1: -2.007,
    x2: 28.563,
    y2: 1.343,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 7.66,
    y1: 2,
    x2: 7.66,
    y2: -0.08,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 10.847,
    y1: 1.129,
    x2: 10.847,
    y2: -0.951,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 24.183,
    y1: 2.954,
    x2: 24.183,
    y2: -0.197,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 24.183,
    y1: -1.312,
    x2: 24.183,
    y2: 0.989,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 42.967,
    y1: 12.231,
    x2: 42.967,
    y2: 10.745,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 31.118,
    y1: 2.965,
    x2: 31.118,
    y2: -5.181,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mov",
    transform: "translate(0 -12.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(52.407 12.16)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 78.667,
    height: 88.535,
    transform: "translate(78.671 29.725)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M142.76,29.725,182.1,0l39.335,29.725v88.535H142.76Z",
    transform: "translate(-142.76)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 157.334,
    transform: "translate(0.004 67.736)",
    fill: "none",
    stroke: "#00365f",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M368.822,29.725H290.155L250.82,0h78.671Z",
    transform: "translate(-211.485)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M403.837,201.36h0c2.038,0,3.687,2.1,3.687,4.7v14.08H400.15v-14.08C400.15,203.464,401.8,201.36,403.837,201.36Z",
    transform: "translate(-345.002 -165.228)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M350.337,201.36h0c2.038,0,3.687,2.1,3.687,4.7v14.08H346.65v-14.08C346.65,203.464,348.3,201.36,350.337,201.36Z",
    transform: "translate(-310.977 -165.228)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M296.687,201.36h0c2.038,0,3.687,2.1,3.687,4.7v14.08H293v-14.08C293,203.464,294.653,201.36,296.687,201.36Z",
    transform: "translate(-276.856 -165.228)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M403.837,320.07h0c2.038,0,3.687,2.1,3.687,4.692v14.08H400.15V324.777C400.15,322.17,401.8,320.07,403.837,320.07Z",
    transform: "translate(-345.002 -240.726)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M350.337,320.07h0c2.038,0,3.687,2.1,3.687,4.692v14.08H346.65V324.777C346.65,322.17,348.3,320.07,350.337,320.07Z",
    transform: "translate(-310.977 -240.726)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M296.687,320.07h0c2.038,0,3.687,2.1,3.687,4.692v14.08H293V324.777C293,322.17,294.653,320.07,296.687,320.07Z",
    transform: "translate(-276.856 -240.726)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M384.688,0H327.68l34.654,29.725h6.541Z",
    transform: "translate(-260.367)",
    fill: "#002746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M456.663,0l15.809,29.725v88.535H440.85V29.725Z",
    transform: "translate(-332.341)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 6.545,
    height: 88.535,
    transform: "translate(108.512 118.261) rotate(180)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M602.828,201.36h0c2.035,0,3.687,2.1,3.687,4.7v14.08H599.14v-14.08C599.14,203.464,600.789,201.36,602.828,201.36Z",
    transform: "translate(-471.557 -165.228)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M0,0H7.375V16.25a2.512,2.512,0,0,1-2.512,2.512H2.515A2.512,2.512,0,0,1,0,16.25V0Z",
    transform: "translate(121.056 54.908) rotate(180)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M602.828,283.74h0c2.035,0,3.687,2.1,3.687,4.692v14.08H599.14v-14.08C599.14,285.84,600.789,283.74,602.828,283.74Z",
    transform: "translate(-471.557 -217.621)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M0,0H7.375V16.26a2.512,2.512,0,0,1-2.512,2.512H2.515A2.512,2.512,0,0,1,0,16.26V0Z",
    transform: "translate(121.056 84.892) rotate(180)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M490.317,204.21h0c2.038,0,3.687,2.1,3.687,4.692v14.08H486.63V208.9C486.63,206.318,488.283,204.21,490.317,204.21Z",
    transform: "translate(-400.002 -167.041)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M490.317,320.07h0c2.038,0,3.687,2.1,3.687,4.692v14.08H486.63V324.777C486.63,322.17,488.283,320.07,490.317,320.07Z",
    transform: "translate(-400.002 -240.726)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M650.958,204.21h0c2.038,0,3.687,2.1,3.687,4.692v14.08H647.27V208.9C647.27,206.318,648.923,204.21,650.958,204.21Z",
    transform: "translate(-502.167 -167.041)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M650.958,320.07h0c2.038,0,3.687,2.1,3.687,4.692v14.08H647.27V324.777C647.27,322.17,648.923,320.07,650.958,320.07Z",
    transform: "translate(-502.167 -240.726)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M579.136,366.11h0c3.487,0,6.316,3.6,6.316,8.041v14.124H572.82V374.151C572.82,369.71,575.648,366.11,579.136,366.11Z",
    transform: "translate(-454.818 -270.007)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 4.565,
    cy: 4.401,
    rx: 4.565,
    ry: 4.401,
    transform: "translate(119.993 15.714)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 4.565,
    cy: 4.401,
    rx: 4.565,
    ry: 4.401,
    transform: "translate(34.771 15.714)",
    fill: "#00365f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 31.622,
    transform: "translate(108.509 61.016)",
    fill: "none",
    stroke: "#00365f",
    strokeMiterlimit: 10,
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M712.24,504.184c0-1.576,11.146-2.854,24.891-2.854s24.891,1.278,24.891,2.854-11.142,2.85-24.891,2.85S712.24,505.756,712.24,504.184Z",
    transform: "translate(-491.52 -356.005)",
    fill: "#00365f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M545.36,497.318c0-1.274,9.017-2.308,20.137-2.308s20.137,1.034,20.137,2.308-9.017,2.308-20.137,2.308S545.36,498.592,545.36,497.318Z",
    transform: "translate(-385.387 -351.986)",
    fill: "#00365f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M409.2,495.309c0-1.74,10.141-3.149,22.649-3.149s22.653,1.409,22.653,3.149-10.141,3.149-22.653,3.149S409.2,497.049,409.2,495.309Z",
    transform: "translate(-298.791 -350.173)",
    fill: "#00365f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 22.649,
    cy: 3.149,
    rx: 22.649,
    ry: 3.149,
    transform: "translate(91.218 135.704)",
    fill: "#00365f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 81.033,
    cy: 4.303,
    rx: 81.033,
    ry: 4.303,
    transform: "translate(0 129.614)",
    fill: "#00365f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 12.926,
    height: 10.979,
    transform: "translate(78.423 82.558) rotate(180)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M405.313,402.807h6.716a12.412,12.412,0,1,1,0,24.824l-6.716,0a12.412,12.412,0,1,1,0-24.824Z",
    transform: "translate(-288.425 -293.344)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M209,415.219a12.413,12.413,0,0,1,12.409-12.409h6.72a12.412,12.412,0,1,1,0,24.824l-6.709,0A12.413,12.413,0,0,1,209,415.219Z",
    transform: "translate(-171.467 -293.348)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M344.139,402.807h-6.72v2a12.376,12.376,0,0,0,0,20.822v2h6.72a12.412,12.412,0,1,0,0-24.824Z",
    transform: "translate(-249.525 -293.344)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M160.3,402.807H153.57v2a12.376,12.376,0,0,0,0,20.822v2H160.3a12.412,12.412,0,1,0,0-24.824Z",
    transform: "translate(-132.599 -293.344)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M149.648,324.711l7.6-22.638a4.874,4.874,0,0,1,4.623-3.323h17.713a3.36,3.36,0,0,1,3.363,3.363v48.559H122.376a4.936,4.936,0,0,1-4.936-4.94h0V331.6a3.91,3.91,0,0,1,3.505-3.891Z",
    transform: "translate(-113.236 -227.167)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M149.629,324.711l7.6-22.638a4.874,4.874,0,0,1,4.623-3.323h17.713a3.36,3.36,0,0,1,3.363,3.363v48.559h-61.3a4.219,4.219,0,0,1-4.219-4.223V331.6a3.91,3.91,0,0,1,3.505-3.891Z",
    transform: "translate(-113.217 -227.167)",
    fill: "#332a88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M1.3,0H4.765A1.139,1.139,0,0,1,5.9,1.139V5.977A1.139,1.139,0,0,1,4.765,7.116H1.3A1.3,1.3,0,0,1,0,5.813V1.3A1.3,1.3,0,0,1,1.3,0Z",
    transform: "translate(7.855 120.478) rotate(180)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M435.93,370.07H383.6L374,396.031h31.731a71.838,71.838,0,0,0,27.239-5.363h0a4.809,4.809,0,0,0,2.981-4.448Z",
    transform: "translate(-276.404 -272.525)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M344.535,370.07H297.41v25.961h31.054l13.086-5.362a4.805,4.805,0,0,0,2.985-4.448Z",
    transform: "translate(-227.694 -272.525)",
    fill: "#68e52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M120.949,327.7l28.7-3,7.6-22.638a4.878,4.878,0,0,1,4.623-3.327h17.713a3.363,3.363,0,0,1,3.363,3.367v22.6h47.125v12.981c-5.409,2.184-4.732,1.715-11.543,1.267-4.6-.3-9.552-4.11-16.2-4.55-3.658-.24-8.1,1.514-11.648,4.281s-28.593.448-35.71,1.041-8.431-.593-13.254-3.156-10.629-1.187-12.595-.51-4.827,3.251-7.684,2.865a5.391,5.391,0,0,1-4-2.865V331.6a3.91,3.91,0,0,1,3.509-3.895Z",
    transform: "translate(-113.236 -227.16)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M190.66,417.11h85.871a4.79,4.79,0,0,1-2.872,3.476l-5.7,2.337H190.66Z",
    transform: "translate(-159.803 -302.442)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 12.409,
    cy: 12.409,
    r: 12.409,
    transform: "translate(72.985 112.615) rotate(-13.14)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 6.112,
    cy: 6.112,
    r: 6.112,
    transform: "translate(81.783 115.76)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 4.292,
    cy: 4.292,
    r: 4.292,
    transform: "translate(83.603 117.58)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M347.438,426.05A4.3,4.3,0,1,0,350.049,430,4.3,4.3,0,0,0,347.438,426.05Z",
    transform: "translate(-257.851 -308.128)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 47.125,
    height: 2.989,
    transform: "translate(116.845 102.295) rotate(180)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M214.922,331.014l7.218-21.477a1.285,1.285,0,0,1,1.216-.877h17.473v22.369h-9.111a8.456,8.456,0,0,0-5.635,2.119l-.51.455H214.11Z",
    transform: "translate(-174.716 -233.469)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M265.647,374.91H253.925a8.468,8.468,0,0,0-6.459,2.99h18.18Z",
    transform: "translate(-195.931 -275.604)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 2.304,
    height: 25.961,
    transform: "translate(72.027 123.502) rotate(180)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M244.929,317.519a66,66,0,0,0-24.389,8.907l5.69-16.959a1.285,1.285,0,0,1,1.216-.877h17.473Z",
    transform: "translate(-178.806 -233.425)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M206.66,350.147V330.556l9.319-24.866a2.821,2.821,0,0,1,2.628-1.82h17.626a1.456,1.456,0,0,1,1.456,1.456v22.547a1.722,1.722,0,0,1,.146,1.944l-.084.127a1.693,1.693,0,0,0-.455,1.689l.295,1.019v16.195a3.542,3.542,0,0,1-3.535,3.538H208.869a2.213,2.213,0,0,1-2.21-2.239Zm30.082-18.386a2.257,2.257,0,0,1,.575-2.22l.018-.029a1.165,1.165,0,0,0-.146-1.369l-.073-.08V305.315a.881.881,0,0,0-.885-.881H218.607a2.253,2.253,0,0,0-2.1,1.456l-9.282,24.72v19.537a1.649,1.649,0,0,0,1.645,1.649h25.186a2.974,2.974,0,0,0,2.97-2.974V332.758Z",
    transform: "translate(-169.978 -230.423)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M267.427,383.12h4.557a1.307,1.307,0,0,1,1.307,1.307h0a1.307,1.307,0,0,1-1.307,1.307h-4.557a1.307,1.307,0,0,1-1.307-1.307h0A1.307,1.307,0,0,1,267.427,383.12Z",
    transform: "translate(-207.794 -280.825)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M263.617,383.12h4.557a1.307,1.307,0,0,1,1.307,1.307h0a1.307,1.307,0,0,1-1.307,1.307h-4.557a1.307,1.307,0,0,1-1.307-1.307h0A1.307,1.307,0,0,1,263.617,383.12Z",
    transform: "translate(-205.371 -280.825)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M413.416,377.226h0a.535.535,0,0,0,.521-.728l-.459-1.558H412l.459,1.558A1.07,1.07,0,0,0,413.416,377.226Z",
    transform: "translate(-300.572 -275.623)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M381.409,377.207h0a.535.535,0,0,0,.521-.728l-.473-1.569H380l.459,1.558A1.067,1.067,0,0,0,381.409,377.207Z",
    transform: "translate(-280.22 -275.604)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M349.4,377.207h0a.535.535,0,0,0,.52-.728l-.462-1.569H348l.459,1.558A1.067,1.067,0,0,0,349.4,377.207Z",
    transform: "translate(-259.869 -275.604)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M317.355,377.207h0a.535.535,0,0,0,.521-.728l-.451-1.569H315.95l.459,1.558a1.07,1.07,0,0,0,.946.739Z",
    transform: "translate(-239.485 -275.604)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 12.409,
    cy: 12.409,
    r: 12.409,
    transform: "translate(3.477 120.438) rotate(-40.29)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 6.112,
    cy: 6.112,
    r: 6.112,
    transform: "translate(14.859 115.76)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 4.292,
    cy: 4.292,
    r: 4.292,
    transform: "translate(16.679 117.58)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M163.548,426.05a4.3,4.3,0,0,0,0,7.9,4.3,4.3,0,0,0,0-7.9Z",
    transform: "translate(-140.899 -308.128)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 6.902,
    height: 2.679,
    rx: 1.34,
    transform: "translate(18.496 106.343) rotate(180)",
    fill: "#c62834"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 6.902,
    height: 2.679,
    rx: 1.34,
    transform: "translate(17.556 106.343) rotate(180)",
    fill: "#ffa627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M88.589,259.53h6.6v5.66h-6.6a.859.859,0,0,1-.859-.859v-3.942a.859.859,0,0,1,.859-.859Z",
    transform: "translate(-55.795 -165.058)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M93.8,259.53h4.79v5.66H93.8a.728.728,0,0,1-.728-.728v-4.193a.728.728,0,0,1,.728-.739Z",
    transform: "translate(-59.191 -165.058)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M95.748,261.77h3.4v4.022h-3.4a.528.528,0,0,1-.528-.528v-2.97A.528.528,0,0,1,95.748,261.77Z",
    transform: "translate(-60.559 -166.482)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M0,0H47.122V43.652a1.532,1.532,0,0,1-1.533,1.532H1.543A1.532,1.532,0,0,1,.011,43.652V0Z",
    transform: "translate(159.525 97.545) rotate(180)",
    fill: "#68e52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M0,0H47.125V43.652a1.532,1.532,0,0,1-1.532,1.532H1.547A1.532,1.532,0,0,1,.015,43.652V0Z",
    transform: "translate(116.845 97.545) rotate(180)",
    fill: "#332a88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M427.08,387.219V370.11h42.608v16.151a4.76,4.76,0,0,1-.109.972Z",
    transform: "translate(-310.163 -272.551)",
    fill: "#68e52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M436.21,383.051V370.07h36.285v12.245a3.111,3.111,0,0,1-.095.728Z",
    transform: "translate(-315.969 -272.525)",
    fill: "#c62834"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 36.288,
    height: 40.893,
    transform: "translate(156.526 97.541) rotate(180)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(120.237 56.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 24.524,
    height: 32.929,
    rx: 2.09,
    transform: "translate(10.808 20.916)",
    fill: "#8b684a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 23.362,
    height: 31.72,
    transform: "translate(8.896 21.52)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 13.843,
    height: 21.149,
    transform: "translate(13.658 26.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M481.477,317.3V345.99H461.19V317.3h20.286m1.063-2.119h-22.39a1.056,1.056,0,0,0-1.059,1.056v30.817a1.056,1.056,0,0,0,1.059,1.056h22.409a1.056,1.056,0,0,0,1.056-1.056V316.239a1.056,1.056,0,0,0-1.056-1.056Z",
    transform: "translate(-450.758 -294.267)",
    fill: "#b98b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M449.843,292.44h-4.514a3.047,3.047,0,0,1-3.047-3.047h0a7.309,7.309,0,0,0-7.313-7.313h0a7.309,7.309,0,0,0-7.309,7.313v7.3a6.094,6.094,0,0,0,6.1,6.1h13.126l2.959-2.184Z",
    transform: "translate(-430.769 -273.216)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M427.66,309.892V302.83a2.807,2.807,0,0,0,2.8,2.807h4.918s-.426,6.651-.047,8.008,3.12,2.33,3.12,2.33h-4.7a6.094,6.094,0,0,1-6.1-6.083Z",
    transform: "translate(-430.769 -286.413)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M434.969,282.08h0a4.078,4.078,0,0,1,.473.018,7.309,7.309,0,0,0-6.836,7.28v.244a2.8,2.8,0,0,0,2.8,2.8h-.946a2.781,2.781,0,0,1-1.856-.728h0a2.792,2.792,0,0,1-.946-2.1v-.24a7.309,7.309,0,0,1,7.309-7.28Z",
    transform: "translate(-430.769 -273.216)",
    fill: "#b096ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M450.1,320.9h9.668a3.058,3.058,0,0,0,3.058-3.054V311.2a.666.666,0,0,0-1.329,0v6.632a1.729,1.729,0,0,1-1.729,1.729H450.1a1.729,1.729,0,0,1-1.729-1.729V311.2a.663.663,0,1,0-1.325,0v6.632A3.054,3.054,0,0,0,450.1,320.9Z",
    transform: "translate(-443.1 -291.316)",
    fill: "#7e62c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 3.025,
    height: 11.474,
    transform: "translate(8.161 41.046) rotate(180)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M0,0H9.985V10.775a.364.364,0,0,1-.364.364H.375a.364.364,0,0,1-.364-.364V0Z",
    transform: "translate(13.596 34.21) rotate(180)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M0,0H8.42V10.775a.364.364,0,0,1-.364.364H.375a.364.364,0,0,1-.364-.364V0Z",
    transform: "translate(5.027 34.21) rotate(180)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 3.677,
    height: 1.525,
    transform: "translate(2.654 24.585) rotate(180)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 3.677,
    height: 1.525,
    transform: "translate(2.654 24.585) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 3.677,
    height: 1.525,
    transform: "translate(2.654 34.214) rotate(180)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 3.677,
    height: 1.525,
    transform: "translate(2.654 34.214) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M359.22,240.667l1.07-1.387,1.07,1.387h-.411v.946h-1.321v-.946Z",
    transform: "translate(-348.696 -208.83)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 2.14,
    height: 0.411,
    transform: "translate(12.664 33.486) rotate(180)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M0,0H19.62V21.167a.728.728,0,0,1-.728.728H.746a.728.728,0,0,1-.728-.728V0Z",
    transform: "translate(33.387 53.87) rotate(180)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M0,0H16.544V21.167a.728.728,0,0,1-.728.728H.739a.728.728,0,0,1-.728-.728V0Z",
    transform: "translate(16.544 53.87) rotate(180)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 7.222,
    height: 2.999,
    transform: "translate(28.353 34.963) rotate(180)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 7.222,
    height: 2.999,
    transform: "translate(28.353 34.963) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 7.222,
    height: 2.999,
    transform: "translate(28.353 53.874) rotate(180)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 7.222,
    height: 2.999,
    transform: "translate(28.353 53.874) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M0,0H15.117V16.308a.572.572,0,0,1-.572.572H.572A.572.572,0,0,1,0,16.308V0Z",
    transform: "translate(19.89 53.87) rotate(180)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M0,0H12.74V16.308a.572.572,0,0,1-.572.572H.572A.572.572,0,0,1,0,16.308Z",
    transform: "translate(6.916 53.87) rotate(180)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 5.566,
    height: 2.311,
    transform: "translate(3.323 39.303) rotate(180)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 5.566,
    height: 2.311,
    transform: "translate(3.323 39.303) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 5.566,
    height: 2.311,
    transform: "translate(3.323 53.874) rotate(180)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 5.566,
    height: 2.311,
    transform: "translate(3.323 53.874) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M372.16,290.077l1.624-2.1,1.62,2.1h-.622v1.431h-2v-1.431Z",
    transform: "translate(-356.926 -239.803)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 3.24,
    height: 0.622,
    transform: "translate(18.477 52.771) rotate(180)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M380.263,343.556h28.866v-9.009H380.263a4.506,4.506,0,1,0,0,9.009Z",
    transform: "translate(-397.677 -306.583)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M455.28,339.056a4.5,4.5,0,1,0,1.319-3.188A4.506,4.506,0,0,0,455.28,339.056Z",
    transform: "translate(-448.335 -306.586)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M459.17,341.53a3.09,3.09,0,1,0,3.09-3.09A3.09,3.09,0,0,0,459.17,341.53Z",
    transform: "translate(-450.809 -309.06)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M462.71,343.782a1.8,1.8,0,1,0,.534-1.281,1.8,1.8,0,0,0-.534,1.281Z",
    transform: "translate(-453.06 -311.312)",
    fill: "url(#linear-gradient-61)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M205.045,366.693a11.816,11.816,0,0,0-3.935-1.7v-.419a.728.728,0,0,1,.728-.728h3.2Z",
    transform: "translate(-166.449 -268.569)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 41.669,
    height: 37.821,
    transform: "translate(113.973 94.472) rotate(180)",
    fill: "#332a88"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 41.669,
    transform: "translate(72.304 64.39)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 41.669,
    transform: "translate(72.304 59.924)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 41.669,
    transform: "translate(72.304 73.327)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 41.669,
    transform: "translate(72.304 68.86)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 41.669,
    transform: "translate(72.304 82.263)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 41.669,
    transform: "translate(72.304 77.793)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 41.669,
    transform: "translate(72.304 91.196)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 41.669,
    transform: "translate(72.304 86.73)",
    fill: "none",
    stroke: "#ffa627",
    strokeMiterlimit: 10,
    strokeWidth: 1.81
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M0,0H14.1V15.216a.531.531,0,0,1-.531.531H.531A.531.531,0,0,1,0,15.216V0Z",
    transform: "translate(125.97 138.853) rotate(180)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M0,0H11.9V15.216a.531.531,0,0,1-.531.531H.539a.531.531,0,0,1-.531-.531V0Z",
    transform: "translate(113.874 138.853) rotate(180)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 5.191,
    height: 2.155,
    transform: "translate(122.352 125.257) rotate(180)",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 5.191,
    height: 2.155,
    transform: "translate(122.352 125.257) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 5.191,
    height: 2.155,
    transform: "translate(122.352 138.849) rotate(180)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 5.191,
    height: 2.155,
    transform: "translate(122.352 138.849) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M0,0H15.117V16.308a.572.572,0,0,1-.572.572H.572A.572.572,0,0,1,0,16.308V0Z",
    transform: "translate(146.035 145.136) rotate(180)",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M0,0H12.74V16.308a.572.572,0,0,1-.572.572H.582a.572.572,0,0,1-.572-.572V0Z",
    transform: "translate(133.061 145.136) rotate(180)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 5.566,
    height: 2.311,
    transform: "translate(129.469 130.568) rotate(180)",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 5.566,
    height: 2.311,
    transform: "translate(129.469 130.568) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 5.566,
    height: 2.311,
    transform: "translate(129.469 145.136) rotate(180)",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 5.566,
    height: 2.311,
    transform: "translate(129.469 145.136) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M388.38,385.16l1.624-2.1,1.62,2.1H391v1.431h-2V385.16Z",
    transform: "translate(-247.004 -243.621)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 3.24,
    height: 0.622,
    transform: "translate(144.619 144.036) rotate(180)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M675.975,494.53c-1.456,0-2.665-1.623-2.665-3.695s1.194-3.746,2.665-3.746h2.184l-.841,7.44Z",
    transform: "translate(-466.762 -346.949)",
    fill: "#4f6060"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 2.035,
    cy: 3.116,
    rx: 2.035,
    ry: 3.116,
    transform: "translate(208.532 140.771)",
    fill: "#6c6c7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M679.688,488.349c.663,0,1.4,1.063,1.4,2.486s-.728,2.486-1.4,2.486-1.405-1.063-1.405-2.486S679.011,488.349,679.688,488.349Zm0-1.259c-1.474,0-2.668,1.678-2.668,3.746s1.194,3.749,2.668,3.749,2.665-1.678,2.665-3.749S681.159,487.09,679.688,487.09Z",
    transform: "translate(-469.121 -346.949)",
    fill: "#272b2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aVYXkO",
    transform: "translate(229.369 60.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M760.961,286.9c.065-.167.076-.364.131-.528.033-.033,0-.029.033,0,.39.033.662.237,1.019.269.524.051,1.052.065,1.573.146a.48.48,0,0,1,.364.157c.047.211-.138.229-.251.284s-.109.12-.026.2a.983.983,0,0,0,.6,1.227c.229.328.339.291.666.251a2.739,2.739,0,0,0,.535-1.139c0-.164-.106-.229-.222-.306s-.24-.1-.182-.266a.441.441,0,0,1,.393,0c.608.16,1.208.346,1.82.55.313.106.939.164.906.5,0,.186-.178.459-.178.644a7.188,7.188,0,0,1-.288.968c-.029.142-.244.306,0,.3.193,0,.207.16.207.295a17.105,17.105,0,0,1-.033,1.933.994.994,0,0,1-.237.579,8.8,8.8,0,0,1-2.475,2.184,5.263,5.263,0,0,1-2.071.608,3.04,3.04,0,0,1-1.092-.157,1.456,1.456,0,0,1-.677-.826,10.578,10.578,0,0,0-.364-1.052,7.251,7.251,0,0,1-.542-3.64c.058-.528.149-1.048.226-1.576-.025-1.147.426-.9.513-.786a1.481,1.481,0,0,0,.568.419c.116.109-.237,1.019-.277,1.136-.073.211-.153.419-.233.626-.2.528.135.608.193.291.084-.44.233-.859.331-1.3a2.184,2.184,0,0,0,0-1.209C761.751,287.239,761.358,287.068,760.961,286.9Z",
    transform: "translate(-751.603 -280.26)",
    fill: "#f4af6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M764.31,272.36c.146,0,.189-.295.244-.389,1.147-1.94,2.683-3.276,5.726-1.511a6.265,6.265,0,0,1,3.014,7.732c-.16.229-.262.269-.48.211-.113.051-.106-.04-.124-.106.073-.146.113-.273-.08-.364-.127-.069-.244-.167-.364-.247a2.81,2.81,0,0,0-.444-.255,10.993,10.993,0,0,0-2.024-.943,1.322,1.322,0,0,1-.408-.182c-.364-.448-.63-.972-.968-1.456a7.2,7.2,0,0,0-3.706-2.457C764.561,272.342,764.372,272.538,764.31,272.36Z",
    transform: "translate(-754.005 -269.632)",
    fill: "#f89800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M769.177,269.919c-2.33-.885-3.622.364-4.623,2.046-.055.095-.1.389-.244.389.062.178.255-.018.382.029a7.143,7.143,0,0,1,3.706,2.457c.339.473.6,1,.968,1.456h0v-.055C769.832,273.836,772,271,769.177,269.919Z",
    transform: "translate(-754.005 -269.626)",
    fill: "#f9e7d7",
    stroke: "#f9e7d7",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M765.74,280.6l-.3.146a2.4,2.4,0,0,1-.834-.364c-.189-.084-.364-.16-.571-.237-1.238-.411-2.472-.819-3.691-1.281a3.275,3.275,0,0,1-1.569-1.07.575.575,0,0,0-1.019.175,6.531,6.531,0,0,0-.175.648c-.04.127.116.364-.036.419h-.08a4.266,4.266,0,0,1-2.639-2.574,1.361,1.361,0,0,1,.364-1.558,1.2,1.2,0,0,1,1.267-.036,4.241,4.241,0,0,1,1.729,1.369c.364.47,4.994,3.12,5.1,3.214C764.088,279.856,764.881,280.085,765.74,280.6Z",
    transform: "translate(-747.904 -272.855)",
    fill: "#db2600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M771.9,313.212c0,.226.612.6.754.557a7.029,7.029,0,0,0,1.875-.961c.058-.044.109-.131.186-.106s.073.149.069.226c0,.309-.055.615-.065.925-.029.9-.459.193-.248,1.172.044.189-.1.266-.215.364a6.411,6.411,0,0,1-1.285.8,1.07,1.07,0,0,1-1.489-.408c-.328-.473-.6-.834-.313-1.427,0,.069.4-.284.582-.44A2.829,2.829,0,0,1,771.9,313.212Z",
    transform: "translate(-758.293 -297.019)",
    fill: "#f4af6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M763.693,279.319a24.6,24.6,0,0,1-3.221-1.118,2.577,2.577,0,0,1-1.023-.841c-.462-.564-.885-1.161-1.376-1.7a3.178,3.178,0,0,0-1.9-1.008,1.092,1.092,0,0,0-.826.4,1.012,1.012,0,0,1,1.23-.539c.692.226,1.365.506,2.049.728a9.944,9.944,0,0,1,2.737,1.219,5.853,5.853,0,0,1,1.82,1.991A5.393,5.393,0,0,1,763.693,279.319Z",
    transform: "translate(-748.307 -272.703)",
    fill: "#e46300",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M762.394,289.252a3.248,3.248,0,0,1-.116,1.951c-.073.3-.127.6-.208.892a.364.364,0,0,0,.269.517,4.224,4.224,0,0,0,.823.226c.1.022.273.022.269.211s-.153.226-.288.24a1.536,1.536,0,0,1-1-.211,1.063,1.063,0,0,1-.459-1.391c.109-.32.364-1.165.364-1.256.095-.51-.189-.728-.662-.688-.062,0-.1.04-.156,0,.026-.207.12-.43,0-.633-.051-.12-.076-.222,0-.262a.9.9,0,0,1,.684.113A2.021,2.021,0,0,1,762.394,289.252Z",
    transform: "translate(-752.013 -281.835)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M783.784,296.729c-.339.036-.386-.211-.324-.426a4.37,4.37,0,0,1,.666-1.5,1.987,1.987,0,0,0,.546-1.551.127.127,0,0,1,.044-.189.142.142,0,0,1,.175.091c.029.047.32.178.364.229a9.577,9.577,0,0,1-.786,2.071,6.025,6.025,0,0,0-.684,1.278Z",
    transform: "translate(-766.169 -284.526)",
    fill: "#342f28",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M762,283.794c.091-.335.215-.728.291-1.07a.652.652,0,0,1,1.187-.233,3.04,3.04,0,0,0,1.456,1.03c1.252.477,2.526.885,3.786,1.329a2.69,2.69,0,0,1,.146,1.456c0,.066-.036.164-.106.167a1.747,1.747,0,0,0-1.092-1.482,5.122,5.122,0,0,0-1.562-.386.142.142,0,0,1-.171.018,3.444,3.444,0,0,0-.954-.248C764.72,284.162,761.913,284.064,762,283.794Z",
    transform: "translate(-752.533 -277.619)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M769.808,290.12c-.342-.171-.688-.313-.728-.8,0-.193,0-.539.076-.6.026-.2.233-.025.364-.033a1.365,1.365,0,0,1,.728.2,2.756,2.756,0,0,0,.9.328,1.905,1.905,0,0,1-.63,1.128c-.091-.116.026-.164.022-.284a.426.426,0,0,0-.3-.426c-.153-.055-.3-.113-.237.167a.262.262,0,0,1-.2.324Z",
    transform: "translate(-757.039 -281.706)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M771.049,291.584c0-.309.171-.288.036-.43s0-.262.207-.226c.517.087.7.539.451.874a.386.386,0,0,1-.7-.218Z",
    transform: "translate(-758.28 -283.17)",
    fill: "#373029",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M761.4,291.356c0-.306.171-.284.036-.426s0-.262.207-.229c.517.091.7.542.451.874a.386.386,0,0,1-.7-.218Z",
    transform: "translate(-752.142 -283.026)",
    fill: "#373029",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M786.846,292.435l-.08-.044a4.721,4.721,0,0,1-.783-.488c-.077-.135.084-.2.062-.364.156.109.677.462.87.582.087.058.131.1.109.142A.364.364,0,0,1,786.846,292.435Z",
    transform: "translate(-767.776 -283.563)",
    fill: "#db3b03",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M782.291,296.483c-.047-.029-.076-.033-.087-.051a.571.571,0,0,1,0-.648c.036-.051.117-.084.153-.018a.7.7,0,0,1,0,.6Z",
    transform: "translate(-765.321 -286.228)",
    fill: "#d4a587",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M772.531,293.306a1.892,1.892,0,0,0,.189-2.29c-1-.987-1.722.877-2,1.522-.062.153-.175.306-.08.488.149-.058.164.029.16.146a6.849,6.849,0,0,1-.364,2.668c-1.056,1.216-3.822,3.087-5.427,2.548a1.54,1.54,0,0,0,.892.233.99.99,0,0,0,.146,0c.794.029,1.973-.684,1.966-.364-.018.466,0,.939-.018,1.405-.084.728,2.311-.459,2.337-.346.153.63-.025,1.118.266,1.729.16.116.291,0,.4-.08.306-.266.6-.539.892-.826.164-.16.346-.364.171-.641a20.555,20.555,0,0,1,.025-4.237.422.422,0,0,1-.2-.51A4.734,4.734,0,0,1,772.531,293.306Z",
    transform: "translate(-754.45 -283.051)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M780.354,290.975a2.147,2.147,0,0,0-.087-1.485,3.968,3.968,0,0,1,1.092.593,4.057,4.057,0,0,0-.954,2.151c-.306.069-.28-.127-.248-.317C780.223,291.6,780.288,291.288,780.354,290.975Z",
    transform: "translate(-764.072 -282.259)",
    fill: "#342e27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M770.941,288.887a.5.5,0,0,1-.55-.033,3.148,3.148,0,0,0-.91-.393c-.153-.022-.681.109-.7,0s.415-.255.535-.309c.43-.189,1.383.364,1.514.444a.208.208,0,0,1,.113.291Z",
    transform: "translate(-756.846 -281.383)",
    fill: "#373129",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M762.281,288.491a.79.79,0,0,1-.284-.062c-.295-.193-.779-.295-.874-.069C760.727,288.032,761.327,287,762.281,288.491Z",
    transform: "translate(-751.899 -281.125)",
    fill: "#3b342c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M763.64,303.47l2.348.135A1.81,1.81,0,0,1,763.64,303.47Z",
    transform: "translate(-753.579 -291.15)",
    fill: "#ec7a2c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M765.493,306.687a.575.575,0,0,1-.484-.109.335.335,0,0,1-.073-.364c.044-.146.178-.1.28-.095s.612.091.586.32A.3.3,0,0,1,765.493,306.687Z",
    transform: "translate(-754.387 -292.828)",
    fill: "#ec7a2c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M804.7,488.5c-.24-.288-.317-.67-.561-.961a3.222,3.222,0,0,0-.8-.79c-.109-.04-.157.04-.178.113a2.4,2.4,0,0,1-.939,1.092c-.459.364-.939.7-1.416,1.041a.866.866,0,0,1-.506.156c-.266.033-.531.076-.8.095-.106,0-.218,0-.28.116-.43.637-.852,1.274-1.292,1.9a5.559,5.559,0,0,1-.6.728,1.624,1.624,0,0,1-1.026.593.946.946,0,0,0-.786.91.99.99,0,0,0,.673.979,3.847,3.847,0,0,0,1.252.164,15.487,15.487,0,0,0,2.785-.164,1.474,1.474,0,0,0,1.012-.59,34.486,34.486,0,0,0,3.371-5.136c.022-.04.04-.08.095-.087Z",
    transform: "translate(-773.846 -407.708)",
    fill: "#773c2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M770.553,412.514a.509.509,0,0,0,.364-.076c.688-.48,1.372-.965,2.013-1.507a1.822,1.822,0,0,0,.455-.663c.036-.08.04-.186.153-.211-.036-.127.051-.222.091-.331a2.941,2.941,0,0,0,.186-.7.99.99,0,0,0-.167-.728c-.175-.251-.306-.531-.459-.8-.029-.051-.04-.138-.109-.142-.215,0-.207-.175-.222-.309a24.607,24.607,0,0,0-1.558-5.824c-.6-1.645-1.194-3.276-1.82-4.929a5.779,5.779,0,0,1-.28-1.784c-.066-1.318-.259-2.621-.364-3.935-.08-1.154-.16-2.308-.259-3.462-.127-1.5-.237-3-.313-4.51-.087-1.613-.167-3.229-.222-4.841q-.131-3.713-.273-7.426a15.419,15.419,0,0,1,.036-1.922,3.662,3.662,0,0,0-.106-.994c-.047-.248-.24-.342-.43-.448a.131.131,0,0,0-.135.073.669.669,0,0,0-.058.149c-.284.83-.531,1.016-1.42,1.067h-.026c-1.092.047-1.092.047-1.718-.841-.3-.422-.612-.845-.917-1.267a.615.615,0,0,0-.317.553c.47.866.9,1.751,1.423,2.585.364.593.382.652-.251.943a27.491,27.491,0,0,1-3.109,1.325c-.364.116-2.574,8.547-2.938,8.7a1.092,1.092,0,0,1-.637.055,27.112,27.112,0,0,1-2.839-.692.535.535,0,0,1-.448-.47c-.069-.419,1.634-9.1,1.529-9.515a.506.506,0,0,0-.127-.291.444.444,0,0,0-.291.025c-.411.109-.823.211-1.238.306-.146.033-.728.051-.793.229.04,3.134.313,6.268.291,9.406a13.689,13.689,0,0,1-.651,3.385q-1.274,4.951-2.548,9.9a5.208,5.208,0,0,0-.149,1.343c.044,2.4-.211,4.78-.364,7.167-.1,1.507-.222,3.01-.331,4.514-.077,1.027-.066,2.057-.164,3.083a10.816,10.816,0,0,1-.393,2.257c.076.1.193.095.295.12,1.7.433,3.429.746,5.154,1.07a.866.866,0,0,1,.437.193c.047-.4.109-.8.142-1.2.175-1.922.455-3.833.746-5.74.24-1.58.455-3.163.673-4.732.2-1.431.393-2.857.673-4.273.055-.266.077-.539.117-.8a15.961,15.961,0,0,1,1.026-3.127c.233-.622.455-1.249.684-1.875a4.025,4.025,0,0,0-.186-.954,29.469,29.469,0,0,1-.5-3.018.557.557,0,0,0-.313-.5,1.518,1.518,0,0,1-.848-1.227c-.124-.59-.28-1.172-.4-1.7a11.787,11.787,0,0,0,1.063,1.456,1.955,1.955,0,0,0,.7.408c.364.153.728.32,1.092.491a.364.364,0,0,1,.244.364,7.062,7.062,0,0,0,.178,1.613c.029.157-.047.3,0,.451.193-.08.135.106.149.164.248.877.484,1.755.728,2.632.524,1.929,1.118,3.837,1.551,5.788a13.3,13.3,0,0,0,.848,2.217c.142-.047.087-.164.073-.248-.364-2.082-.582-4.19-.986-6.268-.157-.79-.364-1.565-.582-2.341-.295-1.114-.441-2.253-.648-3.382a1.53,1.53,0,0,1,0-.408c.066-.8.047-1.605.051-2.406a2.485,2.485,0,0,0-.091-.615,17.231,17.231,0,0,1-.444-5.034c.047-1.074.957-1.376,1.143-2.435a2.355,2.355,0,0,1,.557-1c1.227-.553,1.394-1.387,2.6-1.991.175-.087.273-.095.342.113a9.668,9.668,0,0,0,.364.968c.062.138-.728-.087-.764-.117-.193-.135-.5.029-.728,0a.208.208,0,0,0-.244.127c-.029.106.051.171.131.215.247.135.473.306.728.433a.8.8,0,0,1,.455.83c-.022,2.475,0,4.954-.022,7.43-.022,1.653-.04,3.305-.044,4.962,0,.116-.022.233-.033.364a2.675,2.675,0,0,0,.069,1.019,35.957,35.957,0,0,1,.99,5.191,41.288,41.288,0,0,0,1.62,7.713,58.717,58.717,0,0,1,1.82,6.953,1.729,1.729,0,0,0,.7,1.176,1.743,1.743,0,0,1-.364.036c-.215.025-.262.091-.171.284.127.269.284.524.422.79C770.054,411.6,770.353,412.027,770.553,412.514Z",
    transform: "translate(-744.046 -331.014)",
    fill: "#405673",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M785.172,384.723c-.149-.364-.3-.754-.419-1.139-.044-.146-.087-.146-.2-.087l-2.231,1.165a9.393,9.393,0,0,0-2.483,6.225,17.025,17.025,0,0,0,.63,3.254,9.832,9.832,0,0,1,.073,2.042,10.611,10.611,0,0,0,.069,1.98c.218,1.056.364,2.126.659,3.167a28.092,28.092,0,0,1,.746,3.422c.16,1.056.291,2.115.448,3.171.087.568.193,1.136.295,1.7,0,.062.04.12,0,.175.626,1.507,1.26,3.01,1.878,4.517.728,1.769,1.405,3.553,2.071,5.344.113.3.255.593.4.885a.513.513,0,0,1,0,.444.616.616,0,0,0,0,.517,23.185,23.185,0,0,0,1.114,2.129,1.338,1.338,0,0,1,.273.047h.765c.364-.084.764-.047,1.136-.153.109-.175-.036-.291-.105-.415-.3-.564-.622-1.118-.936-1.674a.51.51,0,0,1-.106-.277c.215-.066.451.04.677-.084a3.908,3.908,0,0,0-.393-.364,2.654,2.654,0,0,1-.484-1.38c-.393-1.82-.823-3.64-1.391-5.431a41.492,41.492,0,0,1-1.423-5.369c-.2-1.147-.364-2.3-.513-3.462a36.073,36.073,0,0,0-1.041-5.307,1.75,1.75,0,0,1-.029-.644c.1-.972.022-1.947.051-2.912.084-2.912.033-5.85.062-8.776a10.774,10.774,0,0,1,0-1.532c.033-.2-.146-.364-.309-.437-.317-.171-.593-.411-.928-.553-.055-.025-.142-.051-.113-.127a.153.153,0,0,1,.2-.087C783.829,384.749,785.3,385.054,785.172,384.723Z",
    transform: "translate(-763.874 -342.023)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M742.389,494.655a2.407,2.407,0,0,0-1.128.615,5.5,5.5,0,0,1-2.81,1.241,6.522,6.522,0,0,0-1.758.4,1.11,1.11,0,0,0-.673,1.227.794.794,0,0,1,0,.186c-.047.5.127.67.637.728a23.205,23.205,0,0,0,3.222,0c1.969-.062,3.939-.044,5.908-.04a.419.419,0,0,0,.459-.313,5.124,5.124,0,0,0,.135-1.176,3.833,3.833,0,0,0,.018-.542,1.015,1.015,0,0,1,.164-.59,1.256,1.256,0,0,0,.149-.859c-.029-.295-.24-.4-.47-.491-.164-.029-.218.1-.291.2a1.314,1.314,0,0,1-.557.419.841.841,0,0,1-.976-.167c-.167-.164-.364-.313-.52-.473a2.046,2.046,0,0,0-1.052-.459A.5.5,0,0,0,742.389,494.655Z",
    transform: "translate(-736.001 -412.667)",
    fill: "#6d2c2a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M767.74,317.491c-.066-.018-.109.018-.157.047-.215.1-.484.091-.619.335a8.575,8.575,0,0,0-.612.786,3.1,3.1,0,0,0-.364,1.369,10.939,10.939,0,0,0,.364,3.349.539.539,0,0,0,.106.273c.142.076.295.033.44.055,1.245,0,2.49-.04,3.731.055a.75.75,0,0,0,.783-.364c.43-.79.728-1.634,1.121-2.453a10.751,10.751,0,0,1,1.209-2.064,1.349,1.349,0,0,0,.284-.455c0-.153-.142-.2-.258-.244a4.707,4.707,0,0,1-.961-.539c-.116,0-.153.106-.215.175a4.56,4.56,0,0,1-.728.823,3.011,3.011,0,0,1-3.116.67,1.329,1.329,0,0,1-.954-1.507C767.77,317.7,767.828,317.586,767.74,317.491Z",
    transform: "translate(-755.066 -300.065)",
    fill: "#f79600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M756.448,323.43a4.8,4.8,0,0,0-.728.615,3.138,3.138,0,0,0-1.2,2c-.364,1.74-.794,3.458-1.092,5.213-.047.288-.1.579-.153.87,0,.12.1.113.164.124a15.687,15.687,0,0,1,1.846.342.244.244,0,0,0,.207-.025,3.407,3.407,0,0,0,.186-.95c.113-.815.324-1.605.5-2.406.033-.142.069-.28.091-.422.08-.473.04-.535-.408-.6.266.029.364-.065.4-.346a7.612,7.612,0,0,0-.08-1.183,1.12,1.12,0,0,1,0-.4,4.989,4.989,0,0,0,0-.808,4.769,4.769,0,0,1,.258-1.722C756.5,323.637,756.608,323.521,756.448,323.43Z",
    transform: "translate(-746.984 -303.845)",
    fill: "#f79600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M772.99,417.344a.545.545,0,0,0,.073-.448,7.113,7.113,0,0,1-.178-1.711.269.269,0,0,0-.193-.3c-.43-.193-.844-.408-1.285-.579a1.987,1.987,0,0,1-.946-.808c-.255-.386-.531-.761-.83-1.187a5.018,5.018,0,0,0,.186,1c.12.546.273,1.092.411,1.62a.433.433,0,0,0,.24.309,1.446,1.446,0,0,0,.164.095c.488.2.582.593.633,1.07a24.231,24.231,0,0,0,.652,3.487c0,.022.033.04.051.062.306-.706.553-1.434.8-2.159a4.786,4.786,0,0,1,.218-.455Z",
    transform: "translate(-757.388 -360.371)",
    fill: "#2e435c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M761.381,320.212c.058.1-.029.178-.058.255a6.367,6.367,0,0,0-.262,2.577,4.395,4.395,0,0,0,.168,1.15c.022.095.04.2.149.237.313-.076.626-.16.943-.218s.419-.2.364-.542-.135-.779-.167-1.176a8.3,8.3,0,0,1,.189-2.843,2.108,2.108,0,0,1,.6-1.034c.073-.066.16-.127.12-.248A5.234,5.234,0,0,0,761.381,320.212Z",
    transform: "translate(-751.917 -300.627)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M753.55,493.091a1.846,1.846,0,0,1,1.7.6c.062.055.116.113.175.171a1.092,1.092,0,0,0,1.736-.149.754.754,0,0,1,.244-.248c0-.229.022-.459.018-.692,0-.142.058-.189.186-.178,0-.12-.113-.095-.186-.106-1.194-.135-2.384-.284-3.578-.4-.087,0-.178-.04-.258.029C753.576,492.443,753.565,492.778,753.55,493.091Z",
    transform: "translate(-747.162 -411.103)",
    fill: "#31435d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M772,317.245c-.6-.244-.728-.535-.571-1.227a2.3,2.3,0,0,0,.113-.608l-.812.761a2.392,2.392,0,0,0-.026.852,1.248,1.248,0,0,0,.582.841,2.183,2.183,0,0,0,1.147.364,3.5,3.5,0,0,0,3.189-1.733.932.932,0,0,0-.666-.28C774.868,316.295,773.521,317.736,772,317.245Z",
    transform: "translate(-758.054 -298.744)",
    fill: "#f7e6d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M761.572,352.09l-.022,1.893c.1,1.059.08,2.126.117,3.189a10.09,10.09,0,0,0-.091,1.369c.43-.171.826-.4,1.234-.615.095-.131.036-.262,0-.39-.255-.914-.437-1.846-.684-2.759a20.951,20.951,0,0,1-.386-2.319C761.714,352.323,761.739,352.159,761.572,352.09Z",
    transform: "translate(-752.25 -322.072)",
    fill: "#405673",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M750.348,490.365a16.232,16.232,0,0,0,1.729.208c.644.1,1.292.153,1.937.247.124.018.247-.1.364.022.106,0,.047-.091.069-.138,0-.146-.065-.211-.226-.24-1.482-.266-2.959-.539-4.426-.874a8.873,8.873,0,0,0-1.234-.269c-.182.426-.146.513.3.6a5.8,5.8,0,0,1,1.489.44Z",
    transform: "translate(-743.923 -409.349)",
    fill: "#1d3046",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M763.985,317.777c-.051.167-.226.222-.331.342a3.4,3.4,0,0,0-.641,1.773,8.742,8.742,0,0,0-.058,1.347,8.638,8.638,0,0,0,.2,1.758c.076.4.044.484-.364.561a2.366,2.366,0,0,0-.874.251c-.077.149-.062.269.116.335a2.488,2.488,0,0,1,1.456-.364c.189-.022.364-.047.564-.065.076,0,.171,0,.186-.116h-.429a.455.455,0,0,1-.331-.415,14.675,14.675,0,0,1-.146-3.458,2.694,2.694,0,0,1,.917-1.718,1.092,1.092,0,0,0,.167-.175.31.31,0,0,1,.251-.138.364.364,0,0,0,.306-.182c0-.091-.073-.076-.142-.066A1.82,1.82,0,0,0,763.985,317.777Z",
    transform: "translate(-752.453 -300.034)",
    fill: "#405673",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M803.123,493.853c-.087-.036-.164-.138-.273-.047C802.926,493.893,803.028,493.853,803.123,493.853Z",
    transform: "translate(-778.516 -412.178)",
    fill: "#4a6481",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M788.108,331.447a4.667,4.667,0,0,1,2.279,1.321.768.768,0,0,1,.211.754,11.154,11.154,0,0,1-1.354,2.843c-.338.6-.808,1.125-1.132,1.74a1.678,1.678,0,0,0,.364.644c.3.426.615.848.9,1.285a.477.477,0,0,0,.389.24,4.544,4.544,0,0,0,1.769-.142.892.892,0,0,0,.535-.491,3.581,3.581,0,0,1,.3-.728c.069-1.037.313-2.046.484-3.069a16.764,16.764,0,0,0,.226-3.018c-.018-1.434.033-2.872.149-4.3.073-.936.131-1.867.124-2.807,0-.175,0-2.461-1.187-3.389a1.409,1.409,0,0,0-1.168-.266,2.464,2.464,0,0,0-1.565,1.15,6.015,6.015,0,0,0-.677,1.318c-.033.091-.084.182-.025.284.156,0,.193-.113.251-.2a4.647,4.647,0,0,1,1.536-1.456,1,1,0,0,1,.994-.175.932.932,0,0,1,.557.553,5.529,5.529,0,0,1,.364,1.685c0,.488,0,.972-.04,1.456a4.092,4.092,0,0,1-.411,1.478c-.408.917-.684,1.886-1.125,2.788a5.175,5.175,0,0,0-.175.539.2.2,0,0,0,0,.08c.364.244.753.364,1.114.593.109.062.233.12.16.288s-.12.2-.28.109a13.093,13.093,0,0,0-1.281-.633,11.235,11.235,0,0,0-1.929-.59.725.725,0,0,0-.266,0C788.162,331.353,788.1,331.363,788.108,331.447Z",
    transform: "translate(-769.139 -302.955)",
    fill: "#e26203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M782.936,322.413a5.16,5.16,0,0,1,.972-1.856,1.874,1.874,0,0,1,2.453-.63.935.935,0,0,0-.451-.7c-.575-.3-1.161-.59-1.707-.939-.2-.124-.408-.033-.608-.066a1.562,1.562,0,0,0-1.216.55c.415.269.848.506,1.267.772.309.2.32.24.058.5a3.462,3.462,0,0,0-.728,1.092c-.364.834-.808,1.634-1.125,2.49a.364.364,0,0,1-.364.244,9.035,9.035,0,0,1-1.536-.084.382.382,0,0,0-.309.036.666.666,0,0,1-.692.342c.033.135.149.12.24.116a12.6,12.6,0,0,1,1.609.186c.364.047.459.135.55.517a5.373,5.373,0,0,1-.062,1.583c-.025.364-.091.728-.084,1.092a.6.6,0,0,0,.051.317c.2.033.167-.146.189-.24.106-.484.207-.972.277-1.456a10.9,10.9,0,0,1,.681-2.362c.087-.284.226-.553.335-.83A2.09,2.09,0,0,0,782.936,322.413Z",
    transform: "translate(-763.316 -300.534)",
    fill: "#405673",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M786,316.794a3.5,3.5,0,0,1,1.212-.542c-.04-.033-.076-.084-.124-.1a4.28,4.28,0,0,1-1.536-.961.626.626,0,0,0-.138-.073.455.455,0,0,0-.364.211,1.638,1.638,0,0,0-.411.823,2.185,2.185,0,0,0,.837.535c.127.058.277.084.364.211C785.95,316.944,785.983,316.9,786,316.794Z",
    transform: "translate(-766.935 -298.56)",
    fill: "#e26203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M783.242,315.252a2.333,2.333,0,0,1,.768-1.034.939.939,0,0,0-.419-.328c-.364-.175-.517-.328-.553-.087a2.748,2.748,0,0,1-.608,1.329l.666.28Z",
    transform: "translate(-765.529 -297.643)",
    fill: "#f4baa7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M771.879,367.73a1.605,1.605,0,0,1-.994.859,30.808,30.808,0,0,1-3.018.826c-1.037.269-2.06.593-3.105.845a2.147,2.147,0,0,0-.32.124c.135.579-1.547,9.435-1.423,10.014.04.175.156.226.3.269a26.987,26.987,0,0,0,2.876.728,1.551,1.551,0,0,0,.845-.051c1.43-.524,6.843-10.254,6.585-10.647C773.033,369.776,772.472,368.636,771.879,367.73Z",
    transform: "translate(-753.18 -332.019)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M769.93,338.221a14.181,14.181,0,0,1,.138-1.962,3.14,3.14,0,0,0,.022-1.045c-.116-.5-.229-.586-.728-.648-.586-.076-1.176-.131-1.762-.2a31.525,31.525,0,0,0-3.8-.055,8.862,8.862,0,0,1-1.351.149,1.594,1.594,0,0,0-.728.189c-.08.051-.153.095-.164.2a.437.437,0,0,0-.124.466,3.732,3.732,0,0,1-.146.728,3.638,3.638,0,0,0-.124.99c-.022.863-.018,1.725,0,2.588a4.4,4.4,0,0,1-.022.619.2.2,0,0,0,.051.178c.036.754.615,3.01.79,3.8s.364,1.573.564,2.359c1.165-.539,2.366-.994,3.495-1.609.466-.251.961-.455,1.427-.728a1.2,1.2,0,0,0,.535-.586c.3-.677.608-1.35.939-2.013a15.659,15.659,0,0,0,.9-2.49.182.182,0,0,0,0-.157.44.44,0,0,1,.109-.568A.215.215,0,0,0,769.93,338.221Z",
    transform: "translate(-751.989 -310.744)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M783.515,319.72c-.051.036-.1.073-.156.106a16.977,16.977,0,0,0-2.264,4.212c-.106.248-.233.484-.364.728a11.57,11.57,0,0,0,1.878.12.364.364,0,0,0,.4-.273,14.07,14.07,0,0,1,.768-1.725,6.36,6.36,0,0,1,.808-1.522c.142-.16.288-.324.444-.473s.109-.248,0-.313A8.759,8.759,0,0,0,783.515,319.72Z",
    transform: "translate(-764.448 -301.485)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M766.785,318.51a2.082,2.082,0,0,0-.815.877,2.773,2.773,0,0,0-.364,1.347,16.774,16.774,0,0,0,.215,3.251c.044.273.16.364.386.288-.1-.51-.233-1.012-.3-1.525a8.039,8.039,0,0,1,.022-2.785,2.494,2.494,0,0,1,.641-1.136C766.65,318.736,766.8,318.688,766.785,318.51Z",
    transform: "translate(-754.824 -300.716)",
    fill: "#e26203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M760.1,337.74v-2.155a11.117,11.117,0,0,1,.124-1.554,1.879,1.879,0,0,0,.106-.648c.033-.164.065-.324.095-.484a.878.878,0,0,1-.1-.331,4.628,4.628,0,0,1-.269-1.132.352.352,0,0,0-.051-.226,2.013,2.013,0,0,0,.025.954c0,.233,0,.466.022.7s-.258.2-.364.317c0,.058.055.036.08.036.32,0,.4.1.335.408-.109.484-.218.965-.335,1.456a18.482,18.482,0,0,0-.411,2.435l.277.113A.5.5,0,0,0,760.1,337.74Z",
    transform: "translate(-750.85 -308.793)",
    fill: "#e26203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M760.268,348.927l-.477-.127a4.425,4.425,0,0,1-.171.754c.186.069.473.055.659.12a2.7,2.7,0,0,0-.011-.746Z",
    transform: "translate(-751.022 -319.98)",
    fill: "#f2b8a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M785.239,331.891a.741.741,0,0,1-.029.251c.131.124.306.1.462.117a12.649,12.649,0,0,1,2.912.728c.084.033.178.109.273.018q.466-1.147.921-2.3c.182-.451.364-.91.546-1.35a3.563,3.563,0,0,0,.306-1.3,7.176,7.176,0,0,0-.1-2.3,5.268,5.268,0,0,0-.244-.772.95.95,0,0,0-1.281-.579,4.285,4.285,0,0,0-1.958,1.714c-.044.066-.062.153-.146.186a3.073,3.073,0,0,0-.277.648c0,.149.117.084.175.058a2.762,2.762,0,0,0,.524-.244,5.5,5.5,0,0,0-1.034.994,10.564,10.564,0,0,0-.728,2.373,10.87,10.87,0,0,1-.324,1.758Z",
    transform: "translate(-767.297 -304.414)",
    fill: "#f79600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M794.777,348.21c-.091.146-.065.364-.277.437a9.72,9.72,0,0,1,1.336.7c.087.065.135.036.189-.055.2-.328.2-.389-.149-.568a8.638,8.638,0,0,0-1.1-.517Z",
    transform: "translate(-773.205 -319.605)",
    fill: "#f4baa6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M788.22,331.848c.342-.229.571-.582.914-.819a.835.835,0,0,0,.244-.258l-.612.248c-.065.025-.131.116-.211.022A3.716,3.716,0,0,0,788.22,331.848Z",
    transform: "translate(-769.211 -308.513)",
    fill: "#e26403",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M692.882,495.188H705.6a3.64,3.64,0,0,0,3.371-2.694l-1.125-.255a2.443,2.443,0,0,1-2.246,1.8H692.882a1.194,1.194,0,0,1-1.234-1.543l-1.121-.255a2.337,2.337,0,0,0,2.355,2.948Z",
    transform: "translate(-477.659 -350.224)",
    fill: "#5a5963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M691.847,422l8.5-37.73a2.548,2.548,0,0,1,2.326-1.86h12.715a1.278,1.278,0,0,1,1.318,1.645l-8.492,37.726.957.218,8.492-37.73a2.253,2.253,0,0,0-2.275-2.843H702.669a3.531,3.531,0,0,0-3.276,2.628l-8.5,37.726Z",
    transform: "translate(-477.942 -279.746)",
    fill: "#c7c7d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M722,381.566h1.638a.983.983,0,0,0,0-1.966H722a.983.983,0,1,0,0,1.966Z",
    transform: "translate(-497.104 -278.586)",
    fill: "#0c1523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M735.613,349.27a.517.517,0,0,1-.069.313,25.825,25.825,0,0,0-1.183,3.189.386.386,0,0,1-.233.269c-1.092.757-5.227,4.612-6.246,5.245a28.779,28.779,0,0,0-2.737,1.536,3.428,3.428,0,0,0,0,2.439,3.04,3.04,0,0,0,.156.28c.091.058.138.164.251.2.328.113.575-.113.521-.524.051.39.058.481.295.648.156.113.728,0,.928-.04a2.141,2.141,0,0,0,.673-.342.258.258,0,0,0,.069-.364c-.273-.459.542-1.416.63-1.35.273.451.906.837,1.048.459a2.464,2.464,0,0,0-.164-1.82.32.32,0,0,1,.146-.437,8.268,8.268,0,0,1,1.336-.728c1.35-.608,2.686-2.752,4.084-3.254.666-.237.7-.5.888-1.172.233-.815.768-2.184,1.019-3,.127-.422.1-.542-.258-.775a8.8,8.8,0,0,0-.888-.575C735.763,349.441,735.741,349.3,735.613,349.27Z",
    transform: "translate(-499.583 -259.297)",
    fill: "#f3ad6c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M736.207,349.062c.073.339.433.335.633.528a2.285,2.285,0,0,0,.561.364.389.389,0,0,1,.186.524c-.295.939-.826,2.446-1.139,3.378-.193.571-.262.7-.819.9-1.3.459-2.548,2.548-3.8,3.127a11.651,11.651,0,0,0-1.583.819.364.364,0,0,0-.171.531,2.283,2.283,0,0,1,.229,1.784c-.1.269-.728,0-1.048-.462-.262-.138-.855,1.092-.7,1.354a.222.222,0,0,1-.12.364c-.116.047-.215.138-.328.186a1.256,1.256,0,0,1-1.136-.058c-.222-.138-.251-.393-.364-.542-.04-.044.153.462-.069.557-.382.12-.837-.491-.633-.095.16.47.266.531.728.411a.3.3,0,0,1,.317.065,4.123,4.123,0,0,0,.364.258.612.612,0,0,0,.659.073c.255-.113.524-.2.775-.324a2.209,2.209,0,0,1,.961-.317.364.364,0,0,0,.364-.251c.2-.437.528-.728.728-1.183.131-.3-.084-.783-.1-1.118a3.277,3.277,0,0,0-.062-.364c-.08-.462.2-.364.626-.528,1.067-.415,4.972-3.123,5.944-3.64a1.216,1.216,0,0,0,.612-.652c.229-.619.688-1.82.914-2.432a1.118,1.118,0,0,1,.167-.328,10.759,10.759,0,0,0-.04-2.25,11.336,11.336,0,0,0-1.387-.386c-.095,0-.186-.193-.28-.2-.248-.047-.488-.12-.728-.178l-.08-.018a.164.164,0,0,0-.149.055A.364.364,0,0,1,736.207,349.062Z",
    transform: "translate(-500.177 -259.096)",
    fill: "#ee9047",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M733.778,382.359h3.276a.983.983,0,1,0,0-1.962h-3.276a.983.983,0,1,0,0,1.962Z",
    transform: "translate(-504.555 -279.092)",
    fill: "#0c1523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M594.874,312.956H578.93l4.659-18.026h15.532Z",
    transform: "translate(-368.192 -187.572)",
    fill: "#d8ae87",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M570.255,341.706H549.71l4.94-18.026h19.857Z",
    transform: "translate(-349.608 -205.856)",
    fill: "#e0b78d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M593.737,366.159H588.55l.571-2.089h5.111Z",
    transform: "translate(-374.31 -231.544)",
    fill: "#f9e7d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M621.358,299.872H617.23l.331-1.722h4.2Z",
    transform: "translate(-392.55 -189.619)",
    fill: "#ffdc83",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(214.403 107.352)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 10.746,
    height: 0.411,
    transform: "translate(0 10.482) rotate(-77.29)",
    fill: "#8e827b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M570.255,373.2H549.71l10.44,7.182H580.7Z",
    transform: "translate(-349.608 -237.35)",
    fill: "#af7c5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M616.291,348.888l-10.771-7.182L610,323.68l10.542,7.182Z",
    transform: "translate(-385.103 -205.856)",
    fill: "#ce986f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M633.267,312.455l-7.6-4.98,3.047-12.675,7.437,4.983Z",
    transform: "translate(-397.918 -187.489)",
    fill: "#ce986f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M749.7,355.617c-1.023.51-2.078.921-3.127,1.412a7.186,7.186,0,0,0-3.607,3.418,2.649,2.649,0,0,0,0,1.34.728.728,0,0,0,.633.579,1.6,1.6,0,0,0,.95-.091c.12-.055.186-.033.269.076a.612.612,0,0,0,1.012.12c.186-.16.342-.28.582-.131.033.022.087,0,.135,0a4.425,4.425,0,0,0,.6-.866.331.331,0,0,0-.087-.422.728.728,0,0,1-.135-.728,9.952,9.952,0,0,0,.248-1.074.644.644,0,0,1,.364-.546,4.807,4.807,0,0,0,1.092-.775,1.365,1.365,0,0,1,.644-.339,37.486,37.486,0,0,0,6.188-2.21,9.1,9.1,0,0,1,1.573-.51,5.772,5.772,0,0,0,1.11-.426.528.528,0,0,0,.269-.291,38.2,38.2,0,0,0,1.6-3.618c.171-.491.4-.965.608-1.456a.506.506,0,0,0-.138-.644,3.64,3.64,0,0,0-1.842-.921.662.662,0,0,0-.386.018,1.413,1.413,0,0,0-.255.673,14.663,14.663,0,0,1-.8,2.042c-.266.593-.59,1.158-.826,1.765a1.31,1.31,0,0,1-.7.688c-1.365.688-2.73,1.365-4.142,1.951-.2.084-.393.186-.59.28-.317.164-.633.324-.954.48A.59.59,0,0,0,749.7,355.617Z",
    transform: "translate(-511.009 -258.167)",
    fill: "#f3ad6c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M765.039,347.594a4.792,4.792,0,0,1,1.405.6c.189.138.342.317.517.473.087.073.069.146.029.237-.622,1.456-1.139,2.981-1.875,4.4a1.821,1.821,0,0,0-.171.4,1.457,1.457,0,0,1-1.267,1.027,23.192,23.192,0,0,0-3.622,1.329,29.909,29.909,0,0,1-4.368,1.456,1.685,1.685,0,0,0-.844.462,3.029,3.029,0,0,1-.874.626.783.783,0,0,0-.48.728,2.916,2.916,0,0,1-.149.564,7.478,7.478,0,0,0-.164.852c0,.131.127.237.215.331a.364.364,0,0,1,.022.521,3.082,3.082,0,0,0-.462.754,1.482,1.482,0,0,0,1.056-.528,2.28,2.28,0,0,0,.575-1.889.342.342,0,0,0-.189-.335c-.131-.055-.1-.113-.069-.226a1.909,1.909,0,0,1,1.321-1.2,3.237,3.237,0,0,1,.5-.1,3.64,3.64,0,0,1,.994-.3c.3-.091.6-.164.906-.244a.408.408,0,0,0,.237-.025c.877-.248,1.769-.444,2.639-.728s1.846-.43,2.752-.728a3.641,3.641,0,0,0,1.5-.666c.16-.146,2.228-3.487,2.821-4.7a5.184,5.184,0,0,0,.364-1.165.666.666,0,0,0-.233-.579,4.485,4.485,0,0,0-2.373-1.38,1.726,1.726,0,0,0-.528-.055.226.226,0,0,0-.182.1Z",
    transform: "translate(-517.411 -258.167)",
    fill: "#ee9047",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M746.015,384.05c0-.135.084-.28-.047-.4s-.142-.087-.167.033c-.058.3-.109.593-.16.892a.084.084,0,0,0,.051.109.153.153,0,0,0,.124-.033c.109-.066.058-.2.138-.28Z",
    transform: "translate(-512.759 -281.11)",
    fill: "#ee9148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M746.51,385.2c.084.058.226.091.237,0s0-.288-.175-.32Z",
    transform: "translate(-513.316 -281.944)",
    fill: "#0f0f0f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M754.923,382.446h.462a.983.983,0,1,0,0-1.966h-.462a.983.983,0,1,0,0,1.966Z",
    transform: "translate(-518.041 -279.146)",
    fill: "#0c1523"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(222.119 107.184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 9.475,
    height: 0.411,
    transform: "translate(0 7.613) rotate(-53.46)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 1.249,
    height: 0.841,
    transform: "translate(221.204 115.674) rotate(-53.46)",
    fill: "#d1d0d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(215.165 115.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M596.215,342.271l.255-.324-4.914-3.851,4.7-17.855,1.383-1.867-.331-.244-1.427,1.929-.011.036-4.776,18.157Z",
    transform: "translate(-591.09 -318.13)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(211.875 107.328)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 8.962,
    height: 0.411,
    transform: "translate(0 7.492) rotate(-56.72)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 1.012,
    height: 0.841,
    transform: "matrix(0.549, -0.836, 0.836, 0.549, 211.134, 115.544)",
    fill: "#d1d0d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(205.191 115.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M567.1,342.02l.317-.266-3.269-3.851,4.707-17.891,1.318-2.006-.346-.226-1.354,2.06-.007.033L563.69,338Z",
    transform: "translate(-563.69 -317.78)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M731.55,379.131a12.471,12.471,0,0,1-.24,1.962l-.728.087-.215-.087a3.129,3.129,0,0,1-.328-.939,11.537,11.537,0,0,1,0-1.234A10.022,10.022,0,0,1,731.55,379.131Z",
    transform: "translate(-502.823 -278.154)",
    fill: "#f3ad6c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M758.3,382.761h.339a.561.561,0,1,0,0-1.121H758.3a.561.561,0,0,0,0,1.121Z",
    transform: "translate(-520.458 -279.884)",
    fill: "#c7c7d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M677.987,489.513a9.578,9.578,0,0,0,4.259,1.208h12.715c1.267,0,1.42-.542.342-1.208l-3.545-2.184a9.577,9.577,0,0,0-4.263-1.209H674.78c-1.263,0-1.42.542-.342,1.209Z",
    transform: "translate(-467.023 -346.332)",
    fill: "none",
    stroke: "#9b9baa",
    strokeMiterlimit: 10,
    strokeWidth: 8.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M684.353,496.646h17.534a.983.983,0,1,0,0-1.966H684.353a.983.983,0,1,0,0,1.966Z",
    transform: "translate(-473.16 -351.776)",
    fill: "#9b9baa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M725.345,494.585c-1.456,0-2.665-1.678-2.665-3.749s1.209-3.746,2.665-3.746h1.492v7.5Z",
    transform: "translate(-498.16 -346.949)",
    fill: "#2e353f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 2.035,
    cy: 3.116,
    rx: 2.035,
    ry: 3.116,
    transform: "translate(226.638 140.771)",
    fill: "#8f8e9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M729.428,488.349c.662,0,1.4,1.063,1.4,2.486s-.728,2.486-1.4,2.486-1.405-1.063-1.405-2.486S728.751,488.349,729.428,488.349Zm0-1.259c-1.474,0-2.668,1.678-2.668,3.746s1.194,3.749,2.668,3.749,2.665-1.678,2.665-3.749S730.9,487.09,729.428,487.09Z",
    transform: "translate(-500.755 -346.949)",
    fill: "#272b2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(231.698 109.941)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 12.722,
    height: 0.411,
    transform: "translate(0 12.391) rotate(-76.9)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(225.277 107.404)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 11.051,
    height: 0.411,
    transform: "translate(0 10.764) rotate(-76.9)",
    fill: "#8e827b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(225.773 121.853)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 18.306,
    height: 0.411,
    transform: "translate(0 17.798) rotate(-76.47)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M641.33,302.137l1.9,1.234.36-1.594-1.769-1.267Z",
    transform: "translate(-407.877 -191.12)",
    fill: "#a07547",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M629.41,333.907l1.893,1.234.364-1.594-1.911-1.267Z",
    transform: "translate(-400.296 -211.326)",
    fill: "#a07547",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M788.562,346.672a12.286,12.286,0,0,0-3.662-.852c-.233.022-.218.659-.062.67a11.474,11.474,0,0,1,3.189.55l.255.095c.218-.033.284-.138.277-.437Z",
    transform: "translate(-537.618 -257.103)",
    fill: "#f7e6d5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M752.814,347.366l-.036-.036c-.284.033-.269.255-.288.455,0,.109.062.135.156.135a21.159,21.159,0,0,0,2.508.586.8.8,0,0,0,.135-.63A11.855,11.855,0,0,0,752.814,347.366Z",
    transform: "translate(-517.119 -258.063)",
    fill: "#f7e6d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M779.56,337.728a.728.728,0,1,0,.728-.728A.728.728,0,0,0,779.56,337.728Z",
    transform: "translate(-534.335 -251.493)",
    fill: "#405673",
    stroke: "#405673",
    strokeMiterlimit: 10,
    strokeWidth: 1.95,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M763.21,337.643a.673.673,0,1,0,.673-.673.673.673,0,0,0-.673.673Z",
    transform: "translate(-523.937 -251.474)",
    fill: "#405673",
    stroke: "#405673",
    strokeMiterlimit: 10,
    strokeWidth: 1.78,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M779.1,337.337a.757.757,0,1,0,.757-.757A.757.757,0,0,0,779.1,337.337Z",
    transform: "translate(-534.043 -251.226)",
    fill: "#7b9ece",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M779.6,337.576a.437.437,0,1,0,.435-.4.437.437,0,0,0-.435.4Z",
    transform: "translate(-534.357 -251.607)",
    fill: "#a8c6ef",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M762.32,337.337a.757.757,0,1,0,.757-.757A.757.757,0,0,0,762.32,337.337Z",
    transform: "translate(-523.371 -251.226)",
    fill: "#7b9ece",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M762.82,337.513a.437.437,0,1,0,.433-.433A.437.437,0,0,0,762.82,337.513Z",
    transform: "translate(-523.689 -251.544)",
    fill: "#a8c6ef",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M589.85,313.014a3.124,3.124,0,0,1,.171-.306,2.11,2.11,0,0,1,.637-.422c.157-.033.087.262,0,.309s-.328.207-.328.207l-.251.131Z",
    transform: "translate(-413.682 -235.774)",
    fill: "#fde583",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M586.608,389.11c-.295-1.82-.506-3.673-.874-5.489h-.106c-.069.593-.138,1.187-.211,1.784-.2,1.645-.175,3.3-.3,4.951-.24,3.065-.936,22.154-.954,23.035a2.39,2.39,0,0,1-.175.8,14.111,14.111,0,0,1-1.773-1.063c-.04-.029-.044-.095-.055-.146.044-1.179.087-2.359.171-3.538.055-.728.073-1.456.1-2.162.033-1.023.062-2.046.113-3.069.178-3.476.127-6.956.156-10.436a13.675,13.675,0,0,1,.175-2.079,11.158,11.158,0,0,0,.04-2.512c-.047-.761-.142-1.518-.153-2.279a.8.8,0,0,0-.448-.728,10.952,10.952,0,0,0-1.343-.662.83.83,0,0,1-.564-.812c-.073-1.285-1.314-6.8-1.391-8.081-.073-1.161,1.256-1.765,1.012-2.184-.08-.233.066-.364.218-.506a24.1,24.1,0,0,1,2.912-2.25,34.216,34.216,0,0,0,3.516-2.712l.612-.5a5.132,5.132,0,0,0,1.19-1.19c.095-.157.193-.364.433-.364.156.084.127.244.153.364a5.915,5.915,0,0,0,.983,2.461,1.689,1.689,0,0,0,1.678.7.506.506,0,0,0,.43-.3,1.565,1.565,0,0,0,.167-.561,3.2,3.2,0,0,0,.077-.728.517.517,0,0,1,.16-.419,2.4,2.4,0,0,1,.24,1.238c.244,2.373.1,4.732.116,7.127,0,1.918-.131,14.484-.16,17.294,0,1.034.069,2.075.087,3.105.029,1.856.542,11.692.659,14.764a24.437,24.437,0,0,1,.022,2.781,2.3,2.3,0,0,1-.066.306.153.153,0,0,1-.084-.124c.04-.506-.3-.681-.681-.87-.455-.229-.9-.466-1.376-.659a.477.477,0,0,1-.324-.309,2.292,2.292,0,0,1-.029-.59c.055-1.5-.036-3-.1-4.488-.08-1.871-.16-3.746-.273-5.617-.051-.874-.084-1.755-.109-2.635-.058-1.926-.117-3.855-.16-5.781a3.738,3.738,0,0,0-1.766-2.879,5.258,5.258,0,0,0-.655-.437A3.353,3.353,0,0,1,586.608,389.11Z",
    transform: "translate(-406.789 -270.522)",
    fill: "#405673",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M579.943,387.11c.291.393-.7.823-.692,1.321.022,1.259,1.179,8.674,1.183,9.29,0,.288.208.419.459.513a12.407,12.407,0,0,1,1.482.728c.306.167.644.422.652.746.025,1.15-.317,10.848-.317,12.777,0,1.219-.069,2.435-.1,3.64-.029,1.347-.1,2.694-.149,4.041-.065,1.656-.193,3.313-.233,4.976a6.878,6.878,0,0,0-.069.779.335.335,0,0,1-.335,0,7.715,7.715,0,0,0-1.583-.426c-.2-.033-.386-.08-.466-.3a.513.513,0,0,0,.106-.477c-.138-1.755-.273-3.509-.422-5.26-.146-1.689-.207-3.385-.269-5.078-.106-2.861-.131-5.726-.273-8.587-.186-3.746.084-7.484.087-11.23a11.014,11.014,0,0,0,.04-1.729c-.248-1.565.044-3.134-.135-4.7,0-.022-.036-.051-.025-.069A1.707,1.707,0,0,1,579.943,387.11Z",
    transform: "translate(-406.687 -283.363)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M599.88,427.88c.248.211,2.752,2.49,3.276,3.16a2.767,2.767,0,0,1,.437,1.027,14.694,14.694,0,0,1,.149,2.646c.106.943.022,1.889.08,2.828.073,1.216.1,2.432.16,3.64.055,1.11.1,2.22.16,3.327.069,1.3.091,2.592.164,3.884.065,1.179.022,2.359.058,3.538-.364.109-.619-.193-.939-.244a.994.994,0,0,0-.462-.025,2.49,2.49,0,0,0-1.347,0,.364.364,0,0,1-.419-.12c-.364-.258-.3-.637-.284-1,.138-3.495-.364-18.419-.571-19.595C600.171,429.929,600.033,428.9,599.88,427.88Z",
    transform: "translate(-420.061 -309.292)",
    fill: "#42759d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M570.618,322.47c.138.218,0,.433,0,.644a10.322,10.322,0,0,0,.612,3.64,6.313,6.313,0,0,1,.156,2.719c-.109,1.172-.229,2.344-.3,3.524-.076,1.31-.076,2.625-.062,3.935,0,.728.051,1.456.084,2.162a2.273,2.273,0,0,0,.065.306c.211.382.076.823.189,1.219v.117a1.321,1.321,0,0,1-.6,1.583.7.7,0,0,0-.229.728c.022.193.047.393-.16.524-.113-.164-.062-.364-.091-.535a46.63,46.63,0,0,1-.306-7.644c0-.346-.113-.5-.441-.553a6.392,6.392,0,0,1-1.693-.506.28.28,0,0,0-.364.051,1.136,1.136,0,0,1-1.354.167,1.052,1.052,0,0,1-.572-1.2,28.353,28.353,0,0,1,.561-3.4,31.844,31.844,0,0,1,3.01-6.188A2.694,2.694,0,0,1,570.618,322.47Z",
    transform: "translate(-398.214 -242.252)",
    fill: "#e46303",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M580.247,284.571c.062-.164.073-.339.124-.51.033-.029,0-.029.029,0,.364.029.637.222.979.258.5.047,1.008.058,1.507.138.127.022.262.029.342.149.044.2-.131.218-.24.269s-.106.116-.026.193a.948.948,0,0,0,.579,1.179c.218.313.324.277.637.237a2.548,2.548,0,0,0,.513-1.092c0-.153-.1-.218-.211-.291s-.229-.095-.175-.255a.38.38,0,0,1,.364,0c.582.153,1.158.331,1.729.528.3.1.9.157.866.48,0,.175-.171.44-.171.619a6.273,6.273,0,0,1-.277.928c-.026.135-.229.291,0,.288s.2.153.2.28a15.807,15.807,0,0,1-.033,1.856.942.942,0,0,1-.226.55,8.689,8.689,0,0,1-2.37,2.086,5.038,5.038,0,0,1-1.966.608,2.869,2.869,0,0,1-1.037-.149,1.394,1.394,0,0,1-.648-.79,10.682,10.682,0,0,0-.364-1.008,6.917,6.917,0,0,1-.517-3.476c.051-.506.138-1.008.211-1.511-.025-1.092.408-.863.491-.754a1.507,1.507,0,0,0,.546.4c.113.106-.226.976-.266,1.092-.069.2-.146.4-.222.6-.189.5.127.579.186.28.08-.422.222-.826.317-1.245a2.053,2.053,0,0,0,0-1.158C581.019,284.9,580.641,284.732,580.247,284.571Z",
    transform: "translate(-407.301 -217.811)",
    fill: "#f4af6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M583.53,270.64c.138,0,.178-.28.233-.364,1.092-1.86,2.57-3.152,5.486-1.456a5.989,5.989,0,0,1,2.887,7.4c-.156.218-.248.258-.459.2-.106.047-.1-.04-.12-.1.073-.138.109-.262-.076-.364-.124-.066-.233-.16-.364-.237a2.392,2.392,0,0,0-.43-.248,10.53,10.53,0,0,0-1.937-.9,1.256,1.256,0,0,1-.39-.175c-.364-.43-.6-.932-.928-1.383a6.974,6.974,0,0,0-3.549-2.355C583.77,270.625,583.588,270.811,583.53,270.64Z",
    transform: "translate(-409.663 -207.629)",
    fill: "#f89800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M588.193,268.308c-2.231-.848-3.473.339-4.43,1.958-.055.091-.095.364-.233.364.058.171.24,0,.364.029a6.914,6.914,0,0,1,3.549,2.355c.324.451.575.954.928,1.383h0a.245.245,0,0,1,0-.051C588.819,272.057,590.894,269.341,588.193,268.308Z",
    transform: "translate(-409.663 -207.627)",
    fill: "#f9e7d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M574.042,491.92a19.359,19.359,0,0,1,2.282.673,9.938,9.938,0,0,1,1.725,1.092,1.81,1.81,0,0,1,0,1.456.364.364,0,0,1-.4.255h-7.28c-.215,0-.6-.488-.659-.826a.7.7,0,0,1,.364-.863c.393-.171.8-.324,1.2-.484a1.867,1.867,0,0,1,1.533.295.677.677,0,0,0,.855-.018c.364-.277.808-.477,1.216-.775a2.813,2.813,0,0,0-.957-.466c-.113-.044-.32.211-.219-.055C573.8,492.146,573.947,491.949,574.042,491.92Z",
    transform: "translate(-400.851 -350.02)",
    fill: "#0c1523",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M600.569,493.056c.342.022.615.258.943.32.542.313,1.121.55,1.685.815.506.24.775.524.692,1.092-.029.7-.142.812-.837.812h-6.8a1.052,1.052,0,0,1-.808-.79.728.728,0,0,1,.437-.939c.364-.16.753-.3,1.128-.448a1.947,1.947,0,0,1,1.565.313.615.615,0,0,0,.783,0c.277-.2.575-.364.866-.539.364-.226.364-.226.164-.564C600.42,493.024,600.485,493.024,600.569,493.056Z",
    transform: "translate(-417.208 -350.731)",
    fill: "#0c1523",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M607.762,354.344a4.284,4.284,0,0,1,1.183.4c.211.1.313.087.382-.175.211-.783.491-1.966.663-2.759a48.047,48.047,0,0,1-.135,4.812,1.3,1.3,0,0,1-.4.473c-.531.426-1.012.914-1.565,1.314a.364.364,0,0,0-.12.521,8.688,8.688,0,0,0,.568,1.037.593.593,0,0,0,.936.2c.131-.076.24-.208.419-.178a1.119,1.119,0,0,1-1.9.728,3.448,3.448,0,0,1-1.165-1.634,11.072,11.072,0,0,1-.462-1.776,18.1,18.1,0,0,0,1.6-2.967Z",
    transform: "translate(-424.055 -260.912)",
    fill: "#b75513",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M584.907,278.56l-.291.142a2.337,2.337,0,0,1-.8-.335c-.178-.08-.364-.157-.546-.226-1.187-.4-2.37-.786-3.538-1.23a3.131,3.131,0,0,1-1.5-1.027.553.553,0,0,0-.976.171,5.724,5.724,0,0,0-.167.619c-.036.12.113.342-.033.4h-.08a4.1,4.1,0,0,1-2.548-2.464,1.3,1.3,0,0,1,.364-1.492,1.147,1.147,0,0,1,1.212-.033,4,4,0,0,1,1.656,1.31c.364.448,4.783,2.989,4.881,3.08C583.309,277.85,584.069,278.072,584.907,278.56Z",
    transform: "translate(-403.81 -210.744)",
    fill: "#db2600",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M590.809,309.785c0,.215.59.579.728.531a6.675,6.675,0,0,0,1.8-.921c.055-.044.1-.124.175-.1s.069.142.066.218c0,.295-.051.59-.058.885-.029.866-.444.186-.24,1.121.044.182-.1.258-.207.346a6.288,6.288,0,0,1-1.227.764,1.027,1.027,0,0,1-1.427-.393c-.317-.455-.571-.8-.3-1.365,0,.062.364-.277.553-.422A2.915,2.915,0,0,1,590.809,309.785Z",
    transform: "translate(-413.779 -233.87)",
    fill: "#f4af6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M582.972,277.308a23.582,23.582,0,0,1-3.083-1.074,2.45,2.45,0,0,1-.983-.8c-.44-.542-.848-1.114-1.318-1.631a3.058,3.058,0,0,0-1.82-.968,1.048,1.048,0,0,0-.768.386.972.972,0,0,1,1.176-.517c.663.218,1.307.488,1.966.728a9.516,9.516,0,0,1,2.621,1.165,5.612,5.612,0,0,1,1.729,1.907A4.969,4.969,0,0,1,582.972,277.308Z",
    transform: "translate(-404.238 -210.57)",
    fill: "#e46300",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M578.712,372.153c.026-.1.091-.215.066-.3a1.17,1.17,0,0,1,.641-1.369.568.568,0,0,0,.226-.615,11.085,11.085,0,0,1-.138-1.853,3.055,3.055,0,0,1,1.631-.564,2.686,2.686,0,0,1,1.6.528.815.815,0,0,0,.32.186c-.477.521-.935,1.063-1.434,1.565-.979.986-1.98,1.955-2.97,2.912Z",
    transform: "translate(-406.559 -270.859)",
    fill: "#293f59",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M600.735,313.8a7.573,7.573,0,0,0-1.642,1.682.9.9,0,0,1-.491.1c-.932-.08-1.867-.106-2.788-.273-.218-.1-.1-.2,0-.277s.342-.193.513-.295a16.848,16.848,0,0,0,2.235-1.8,1.068,1.068,0,0,0,.2-.291c.051-.091.113-.189.244-.106A14.519,14.519,0,0,1,600.735,313.8Z",
    transform: "translate(-417.396 -235.92)",
    fill: "#f89800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M612.124,368.4a3.181,3.181,0,0,1-.364.255.684.684,0,0,1-1.092-.222c-.208-.346-.386-.728-.59-1.063a.408.408,0,0,1,.117-.6c.7-.568,1.383-1.158,2.071-1.736v2.224A5.293,5.293,0,0,1,612.124,368.4Z",
    transform: "translate(-426.492 -269.32)",
    fill: "#f89800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M576.657,492.49a2.737,2.737,0,0,1,1.176.6l-1.747,1.074a.189.189,0,0,1-.251,0,2.873,2.873,0,0,0-1.795-.582,9.921,9.921,0,0,1,2.617-1.088Z",
    transform: "translate(-403.627 -350.383)",
    fill: "#717173",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M603.227,492.857c.109.106.277.142.364.313l-1.7,1.034c-.1.058-.186.087-.284,0a2.882,2.882,0,0,0-1.791-.579,10.718,10.718,0,0,1,1.82-.939,1.973,1.973,0,0,1,1.34.076C603.1,492.708,603.162,492.777,603.227,492.857Z",
    transform: "translate(-420.023 -350.455)",
    fill: "#717173",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M581.719,286.787a3.127,3.127,0,0,1-.113,1.871c-.069.284-.124.575-.2.855a.364.364,0,0,0,.255.5,4.224,4.224,0,0,0,.79.215c.1.022.262.022.258.2s-.146.215-.277.229a1.478,1.478,0,0,1-.961-.2,1.008,1.008,0,0,1-.437-1.329c.1-.309.335-1.117.364-1.2.087-.488-.182-.706-.637-.659-.058,0-.095.04-.149,0,.025-.2.116-.415,0-.608-.051-.113-.076-.211,0-.251a.888.888,0,0,1,.655.106A2.121,2.121,0,0,1,581.719,286.787Z",
    transform: "translate(-407.779 -219.299)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M602.193,294c-.328.036-.364-.2-.309-.4a4.083,4.083,0,0,1,.637-1.456,1.882,1.882,0,0,0,.521-1.467.12.12,0,0,1,.044-.178.131.131,0,0,1,.167.084c.029.047.306.175.335.222a9.182,9.182,0,0,1-.753,1.984A5.754,5.754,0,0,0,602.193,294Z",
    transform: "translate(-421.322 -221.914)",
    fill: "#342f28",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M586.644,314.66c.339.389.029,1.412.4,1.776a4.4,4.4,0,0,1-2.108-.1c0-.291.269-.364.422-.539A11.468,11.468,0,0,1,586.644,314.66Z",
    transform: "translate(-410.559 -237.285)",
    fill: "#f79801",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M584.651,319.27l2.108.1a1.456,1.456,0,0,0,1.82.149c1.128.087,2.25.237,3.382.262-.6,1.121-1.2,2.239-1.8,3.363a.459.459,0,0,1-.364.284,25.434,25.434,0,0,1-3.684.186c-.779,0-1.019-.382-1.2-1.041a7.191,7.191,0,0,1-.422-2.381,2.838,2.838,0,0,1,.156-.921Z",
    transform: "translate(-410.271 -240.217)",
    fill: "#b75513",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M598.648,358.77l-.568.7A.775.775,0,0,1,598.648,358.77Z",
    transform: "translate(-418.916 -265.339)",
    fill: "#384a61",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M608.767,493.011l-.237-.08a.27.27,0,0,1,.393,0C608.861,492.942,608.8,492.949,608.767,493.011Z",
    transform: "translate(-425.562 -350.609)",
    fill: "#1e2837",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M581.336,281.6c.087-.32.2-.7.277-1.027a.626.626,0,0,1,1.139-.226,2.912,2.912,0,0,0,1.394.99c1.2.455,2.421.845,3.64,1.274a2.548,2.548,0,0,1,.138,1.391c0,.062-.033.157-.1.16a1.672,1.672,0,0,0-1.034-1.42,4.932,4.932,0,0,0-1.5-.364.138.138,0,0,1-.164.018,3.447,3.447,0,0,0-.914-.237C583.935,281.946,581.245,281.858,581.336,281.6Z",
    transform: "translate(-408.266 -215.28)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M588.8,287.659c-.328-.164-.655-.3-.684-.764,0-.182,0-.517.076-.579.022-.2.222-.022.339-.029a1.329,1.329,0,0,1,.681.186,2.6,2.6,0,0,0,.859.313,1.869,1.869,0,0,1-.6,1.092c-.087-.109.026-.157.022-.269a.408.408,0,0,0-.284-.408c-.149-.055-.291-.109-.226.16A.255.255,0,0,1,588.8,287.659Z",
    transform: "translate(-412.582 -219.199)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M589.971,289.06c0-.295.167-.273.036-.411s0-.251.2-.218c.5.087.666.517.433.837a.364.364,0,0,1-.666-.207Z",
    transform: "translate(-413.749 -220.6)",
    fill: "#373029",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M580.735,288.89c0-.295.164-.273.033-.408s0-.255.2-.222c.495.087.666.521.433.837a.364.364,0,0,1-.666-.207Z",
    transform: "translate(-407.873 -220.492)",
    fill: "#373029",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M605.122,289.842l-.077-.04a4.486,4.486,0,0,1-.75-.47c-.073-.127.08-.193.058-.342.149.106.648.444.834.561.084.051.124.091.106.135A.364.364,0,0,1,605.122,289.842Z",
    transform: "translate(-422.857 -220.96)",
    fill: "#db3b03",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M600.758,293.74c-.051-.025-.076-.029-.087-.047a.542.542,0,0,1,0-.619c.036-.051.113-.084.146-.018a.67.67,0,0,1,0,.572C600.8,293.664,600.78,293.693,600.758,293.74Z",
    transform: "translate(-420.502 -223.522)",
    fill: "#d4a587",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M579.255,318.294a6.807,6.807,0,0,1,1.82-1.634c.189-.16.364-.393.6-.226.113.109,0,.153-.065.193a1.092,1.092,0,0,0-.291.593,4.583,4.583,0,0,0,.149,2.672c.117.32.193.655.306.976a.63.63,0,0,0,.579.44,16.329,16.329,0,0,0,3.84-.1.728.728,0,0,0,.568-.422c.593-1.034,1.292-2.548,1.7-3.145a5.246,5.246,0,0,1,1.747-1.682.761.761,0,0,1,.8.149c.484.4.983.775,1.478,1.161a.259.259,0,0,1,.127.266,2.454,2.454,0,0,0-1.82.411,3.531,3.531,0,0,0-1.052,1.634c-.117.364-.215.728-.324,1.092a31.136,31.136,0,0,0-.841,3.353c-.419,2.1-.8,4.219-1.38,6.29a5.494,5.494,0,0,1-.513,1.194,1.092,1.092,0,0,0-.6.75,15.113,15.113,0,0,1-1.4,1.795c-.331.389-.673.768-1.016,1.147-.091.1-.171.2-.317.215a.757.757,0,0,1-.455-.2,2.446,2.446,0,0,0-2.676-.12c-.149.08-.3.24-.495.084a.531.531,0,0,1-.106-.335c-.066-1.846-.127-3.691-.033-5.54.087-1.733.273-3.451.411-5.176a3.59,3.59,0,0,0-.208-1.314,14.921,14.921,0,0,1-.612-2.763A3.8,3.8,0,0,1,579.255,318.294Z",
    transform: "translate(-406.851 -238.076)",
    fill: "#405773",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M602.188,314.987a4.152,4.152,0,0,1,1.365-1.19,14.515,14.515,0,0,0-1.718-1.256c-.131-.084-.193,0-.244.106a1.068,1.068,0,0,1-.2.291c-.43.364-.837.75-1.27,1.092h0A17.514,17.514,0,0,1,602.188,314.987Z",
    transform: "translate(-420.214 -235.916)",
    fill: "#e46303",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M591.388,290.71a1.811,1.811,0,0,0,.178-2.184c-.961-.946-1.649.841-1.911,1.456-.062.146-.171.291-.08.466.146-.055.156.029.156.138a6.234,6.234,0,0,1-.364,2.548c-1.008,1.161-3.64,2.956-5.2,2.432a1.482,1.482,0,0,0,.855.226h.138c.761.025,1.893-.655,1.882-.364v1.347c-.084.7,2.213-.44,2.239-.335.146.6-.025,1.074.255,1.656.153.116.277,0,.364-.073.291-.255.582-.517.855-.79.157-.157.331-.364.164-.615a19.424,19.424,0,0,1,.025-4.062.4.4,0,0,1-.193-.484A4.455,4.455,0,0,1,591.388,290.71Z",
    transform: "translate(-410.07 -220.492)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M598.91,288.52a2.068,2.068,0,0,0-.084-1.42,3.846,3.846,0,0,1,1.056.568,3.885,3.885,0,0,0-.914,2.06c-.295.066-.273-.12-.24-.306C598.786,289.109,598.848,288.807,598.91,288.52Z",
    transform: "translate(-419.317 -219.758)",
    fill: "#342e27",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M589.88,286.472a.48.48,0,0,1-.528-.029,2.88,2.88,0,0,0-.87-.364c-.146-.025-.652.1-.673-.018s.4-.24.513-.295c.411-.182,1.325.364,1.456.426a.2.2,0,0,1,.1.28Z",
    transform: "translate(-412.383 -218.885)",
    fill: "#373129",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M581.587,286.1a.772.772,0,0,1-.269-.058c-.284-.186-.75-.284-.837-.065C580.1,285.657,580.673,284.67,581.587,286.1Z",
    transform: "translate(-407.647 -218.642)",
    fill: "#3b342c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M582.89,300.45l2.25.127A1.734,1.734,0,0,1,582.89,300.45Z",
    transform: "translate(-409.256 -228.248)",
    fill: "#ec7a2c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M584.654,303.511a.575.575,0,0,1-.466-.106.32.32,0,0,1-.069-.364c.04-.138.171-.1.269-.091s.586.087.561.306a.3.3,0,0,1-.295.255Z",
    transform: "translate(-410.019 -229.832)",
    fill: "#ec7a2c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M594.526,311.509a7.727,7.727,0,0,1-1.067,1.092c-.677.63-3,2.8-4.164,1.594a1.5,1.5,0,0,1-.051-2.428,1.911,1.911,0,0,0,.364,1.434.912.912,0,0,0,1.31.342,26.123,26.123,0,0,0,2.635-2.013.6.6,0,0,0,.186-.491,1.951,1.951,0,0,0-.026-.222c-.022-.076.237.1.364.226A5.4,5.4,0,0,0,594.526,311.509Z",
    transform: "translate(-412.906 -234.83)",
    fill: "#fde583",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M601.631,331.581l-1.758-.331-.073.364.091.018a.815.815,0,0,0,1.58.295l.091.018Z",
    transform: "translate(-420.01 -247.836)",
    fill: "#293f59",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M583.357,331.09l-1.747.389.084.364.087-.018a.815.815,0,0,0,1.569-.364l.091-.022Z",
    transform: "translate(-408.442 -247.735)",
    fill: "#293f59",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M464.46,267.352l-10.567-.957L452.12,252.34l13.469,1.172Z",
    transform: "translate(-287.542 -160.485)",
    fill: "#ce986f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(171.686 92.557)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 13.974,
    height: 0.393,
    transform: "translate(0 13.942) rotate(-86.09)",
    fill: "#ce986f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M444.811,265.8l-6.971-.819,1.183-13.574,7,.746Z",
    transform: "translate(-278.46 -159.893)",
    fill: "#e0b78d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M470.42,230.678l-13.17-1.147L461.6,215.99l10.021.848Z",
    transform: "translate(-290.805 -137.367)",
    fill: "#ce986f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M452.82,228.743l-7.71-.673,1.2-13.76,7.63.593Z",
    transform: "translate(-283.084 -136.298)",
    fill: "#e0b78d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M567.8,370.478a1.85,1.85,0,0,0-.364.488l-.189.175c-.182.164-.364.331-.542.51a.186.186,0,0,1-.153.073.488.488,0,0,1-.127-.022l-.215-.062a2.607,2.607,0,0,0-.794-.16,1.351,1.351,0,0,0-.244.022c-.888.156-1.787.328-2.654.5l-.75.142h-.029a.488.488,0,0,0-.462.386.615.615,0,0,0,.222.557,1.092,1.092,0,0,0,.783.284h1.183a.9.9,0,0,1,.4.091l-.2.171a4.729,4.729,0,0,0-.757.728,1.78,1.78,0,0,1-1.5.837,2.634,2.634,0,0,1-.364-.029,1.113,1.113,0,0,0-.175,0,.433.433,0,0,0-.328.127.4.4,0,0,0-.047.062l6.374.531a1.614,1.614,0,0,0,.138-.167c.073-.1.142-.211.218-.32a5.7,5.7,0,0,1,.735-.932h0l.018-.036a3.276,3.276,0,0,1,.986-.99l.04-.026.047-.04a25.846,25.846,0,0,1,3.2-2.548l.408-.284.462-5.54C572.047,366.158,570.388,367.89,567.8,370.478Z",
    transform: "translate(-395.009 -269.301)",
    fill: "#ce986f",
    fillRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M448.947,258.089l-2.887-.735.306-1.194,2.857.721Z",
    transform: "translate(-283.688 -162.914)",
    fill: "#f9e7d7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M568.354,367.083a3.334,3.334,0,0,0-1.037,1.052,7.891,7.891,0,0,0-.9,1.2,1.576,1.576,0,0,1-1.067.572c-.386.091-.677.055-1.092.178a3.4,3.4,0,0,1-1.747-.029,4.506,4.506,0,0,0-1.58-.273c-.251,0-.3-.222-.306-.422s.178-.2.309-.182a1.929,1.929,0,0,0,1.973-.819,6.621,6.621,0,0,1,.943-.888c.156-.142.142-.215-.051-.3a1.253,1.253,0,0,0-.561-.138h-1.092a.819.819,0,0,1-.582-.2.335.335,0,0,1-.135-.309c.026-.149.16-.156.273-.178,1.067-.2,2.133-.408,3.2-.6a2.413,2.413,0,0,1,1.07.186.451.451,0,0,0,.5-.109c.229-.233.473-.448.728-.673a1.417,1.417,0,0,1,.331-.43c1.03-1.027,5.045-5.034,6.421-6.782a26.429,26.429,0,0,0,1.387-2.308,3.517,3.517,0,0,1,1.241.222c.63.226,1.263.444,1.885.684.131.051.28.076.364.218a.281.281,0,0,1,0,.229,21.368,21.368,0,0,1-1.605,2.8,28.256,28.256,0,0,1-5.824,4.9A25.032,25.032,0,0,0,568.354,367.083Z",
    transform: "translate(-395.098 -263.335)",
    fill: "#f4af6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M608.306,334.365c-.055.186-.171.339-.364.266l-3.152-1.238-.39-.167a.517.517,0,0,1,.484-.084c.3.047.6.076.9.113.422.055.5,0,.619-.411a43.563,43.563,0,0,0,.957-4.31c.364-2,.568-4.033.848-6.05a1.277,1.277,0,0,0,0-.237c-.051-.866-.328-1.008-1.045-.546a7.2,7.2,0,0,0-1.325,1.23c-.116.131-.506,1.147-.728,1.092.262-1.034.834-2.879,1.722-3.611a1.584,1.584,0,0,1,1.842-.306,1.711,1.711,0,0,1,.783,1.212c.331,2.14-.342,8.805-.491,10Z",
    transform: "translate(-422.936 -240.638)",
    fill: "#e46303",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M603.266,324.846c.673-1.569,1.23-2.246,1.867-2.293s.764.324.877.637a3.566,3.566,0,0,1,.1,1.42c-.164,1.241-.288,2.486-.484,3.72-.211,1.34-.481,2.672-.728,4-.153.8-.364,1.576-.582,2.359-.065.251-.171.364-.43.331-.546-.058-1.03-.051-1.573-.106a6.55,6.55,0,0,0-1.3-.364c.644-2.57,1.147-5.169,1.66-7.768a11.933,11.933,0,0,1,.586-1.94Z",
    transform: "translate(-420.786 -242.302)",
    fill: "#f89800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M604.22,336.4a7.848,7.848,0,0,1,1.4-2.632c-.288,0-1.179.826-1.092,1.15Z",
    transform: "translate(-422.821 -249.439)",
    fill: "#e46303",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M546.537,354.4a1.369,1.369,0,0,1,.936.364.542.542,0,0,1,.207.7.55.55,0,0,1-.633.28c-.12-.018-.273-.124-.335.066s.073.266.2.342a3.036,3.036,0,0,1,.637.524.59.59,0,0,1,0,.9.517.517,0,0,0-.127.426c0,.44-.153.593-.59.612-.175,0-.266.033-.295.222s-.095.313-.288.328a.5.5,0,0,1-.43-.233.433.433,0,0,1-.106-.208,4.438,4.438,0,0,1,.222-1.383c.047-.186.091-.288,0-.459-.339-.568-.335-.586.146-1.092a.16.16,0,0,0,.022-.233,2.286,2.286,0,0,1-.146-.28C545.765,354.735,546,354.4,546.537,354.4Z",
    transform: "translate(-385.603 -262.559)",
    fill: "#ce986f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M545.534,354.19a1.365,1.365,0,0,1,.936.346.539.539,0,0,1,.2.7.546.546,0,0,1-.63.284c-.12-.022-.273-.124-.335.066s.073.262.2.342a2.81,2.81,0,0,1,.633.521.586.586,0,0,1,0,.9.532.532,0,0,0-.124.43c0,.437-.153.593-.593.608-.171,0-.262.033-.291.222s-.095.313-.288.328a.586.586,0,0,1-.535-.44,4.327,4.327,0,0,1,.222-1.38c.044-.186.091-.288,0-.459-.342-.568-.335-.59.146-1.092.091-.095.065-.153.022-.237a2.282,2.282,0,0,1-.146-.28C544.755,354.521,544.992,354.19,545.534,354.19Z",
    transform: "translate(-384.964 -262.425)",
    fill: "#f4af6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 13.661,
    height: 0.394,
    transform: "translate(165.124 90.618) rotate(-85.426)",
    fill: "#ce986f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(165.525 93.195)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M562.951,385.653a.819.819,0,0,0,.582.2h1.092a.854.854,0,0,1,.255.029l.1-.091c.157-.142.142-.215-.047-.3a1.267,1.267,0,0,0-.564-.138h-1.092a.881.881,0,0,1-.426-.095.2.2,0,0,0-.036.084A.335.335,0,0,0,562.951,385.653Z",
    transform: "translate(-562.012 -375.381)",
    fill: "#f09148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M578.8,358.313a.47.47,0,0,0-.291-.193,21.6,21.6,0,0,1-1.573,2.719,28.29,28.29,0,0,1-5.824,4.9,24.42,24.42,0,0,0-3.04,2.428,3.375,3.375,0,0,0-1.034,1.034,8.15,8.15,0,0,0-.9,1.2,1.569,1.569,0,0,1-1.063.572c-.386.091-.681.055-1.092.178a3.4,3.4,0,0,1-1.747-.029,4.416,4.416,0,0,0-1.576-.269h-.051a.273.273,0,0,0,0,.08c0,.2.055.437.306.422a4.506,4.506,0,0,1,1.58.273,3.4,3.4,0,0,0,1.747.029c.415-.124.706-.087,1.092-.178a1.576,1.576,0,0,0,1.067-.572,7.9,7.9,0,0,1,.9-1.183,3.335,3.335,0,0,1,1.034-1.034,25.029,25.029,0,0,1,3.036-2.432,28.488,28.488,0,0,0,5.824-4.9,21.367,21.367,0,0,0,1.605-2.8A.28.28,0,0,0,578.8,358.313Z",
    transform: "translate(-560.612 -358.12)",
    fill: "#f09148",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M457.7,217.074l-1.689-.462.189-1.6,1.7.131Z",
    transform: "translate(-290.016 -136.743)",
    fill: "#a07547",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M473.5,256.808l-1.682-.164.189-2.064,1.7.131Z",
    transform: "translate(-300.071 -161.909)",
    fill: "#a07547",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 0.317,
    height: 10.505,
    transform: "translate(167.553 92.442) rotate(-85.01)",
    fill: "#e0b78d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M481.054,224.335l-2.912.641-.262-1.2,2.876-.641Z",
    transform: "translate(-303.925 -141.908)",
    fill: "#dbbfa7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M604.21,356.914a.28.28,0,0,0,0-.229c-.08-.142-.229-.167-.364-.218-.622-.24-1.256-.459-1.886-.684a3.517,3.517,0,0,0-1.241-.222l-.149.269,2.77,2.708a17.9,17.9,0,0,0,.87-1.624Z",
    transform: "translate(-420.5 -263.297)",
    fill: "#f09148",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner2);
export default __webpack_public_path__ + "static/media/banner2.44d257c5af6550f2efd00a5718fdd4e5.svg";
export { ForwardRef as ReactComponent };